<template>
  <yd-layout>
    <div id="Home" ref="scroll0" @click.stop="tohide">
      <div class="top">
        <div class="top-logo" style="display: flex; align-items: center">
          <!-- <img :src="imagesAddressAddressZh+'/logo.png'" alt /> -->
          <img src="https://yuanzilian-image.oss-cn-hangzhou.aliyuncs.com/applea_images/a8aca23b-f88a-4e62-8feb-6d0e9b3ca1c8.png" alt />

          <!--https://ch.m.atoshi.org/#/?VNK=4e5e4a26&lang=zh_CN-->
          <!--https://en.m.atoshi.org/#/?VNK=156c3283&lang=en-->
          <select
            v-model="languageType"
            id="yuyan"
            style="
              width: 70px;
              height: 30px;
              border: 1px solid #dcdee2;
              border-radius: 4px;
              position: relative;
              margin-left: 5px;
              padding-left: 10px;
            "
            @change="gaibian"
          >
            <option
              value="zh"
              style="height: 30px"
              id="one"
            >
              CH
            </option>
            <option
              value="en"
              style="height: 30px"
              id="two"
            >
              EN
            </option>
          </select>
          <!--<img src="../assets_ch/xiala.png" style="width:10px;height:8px;margin-left:-42px" alt=""/>-->
          <!--<el-switch-->
          <!--v-model="value1"-->
          <!--active-text="中文"-->
          <!--inactive-text="ENG"-->
          <!--active-color="#13ce66"-->
          <!--inactive-color="#ff4949"-->
          <!--active-value="中文"-->
          <!--inactive-value="英文"-->
          <!--@change="tiaozhuan">-->
          <!--</el-switch>-->
        </div>
        <div class="top-right">
          <div @click="menuMenu()">
            <img :src="imagesAddressAddressZh+'/menu.png'" alt />
          </div>
          <div @click="gotoApp()">
            <button @click="gotoScroll9">获取原子币</button>
          </div>
        </div>
      </div>
      <div class="tops">
        <div class="tops_cont">
          <p @click="gotoScroll0">首页</p>
          <p @click="gotoScroll1">为什么选择原子币？</p>
          <p @click="gotoScroll2">原子币是怎么保值和增值的？</p>
          <p @click="gotoScroll3">原子币的应用场景</p>
          <p @click="gotoScroll11">原子链的发展历程</p>
          <p @click="gotoScroll4">宣传资料</p>
          <p @click="gotoScroll5">常见问题</p>
          <!-- <p @click="gotoScroll6">团队介绍</p> -->
          <p @click="gotoScroll7">加入我们</p>
          <p @click="gotoScroll10">天使投资</p>
          <p @click="downloadApp('https://scan.atoverse.info')">测试网</p>
        </div>
      </div>

      <div class="banner" id="particles">
        <vue-particles
          color="#8ceef7"
          :particleOpacity="0.9"
          :particlesNumber="200"
          shapeType="circle"
          :particleSize="4"
          linesColor="#6cc1eb"
          :linesWidth="1"
          :lineLinked="true"
          :lineOpacity="0.4"
          :linesDistance="150"
          class="lizi"
        ></vue-particles>
        <div style="padding-top: 0.5rem">
          <Swiper ref="swiper" id="swiper">
            <Slide v-for="(item, index) in imgFont" :key="index">
              <img :src="item" ref="swiperimg" class="sizeImg" />
            </Slide>
          </Swiper>
        </div>
        <div class="audio" @click="playerVideo(bannerVideo,'home')">
          <div class="audioCenter">
            <div class="audio-img">
              <img :src="imagesAddressAddressZh+'/shouye-bofang.png'" alt />
            </div>
            <div class="audio-font">什么是原子币?</div>
          </div>
        </div>
        <div class="fontFont">原子币: {{ findPrice }} USDT/枚</div>
        <div class="fontFont2">总注册用户: {{ userNums }} </div>
        <div style="display: flex;align-items: center;justify-content: center;">
            <div style="display: flex;align-items: center;justify-content: center;width: 22vw;height: 7vw;color: #fff;font-size: 3vw;background: rgba(0,0,0,.2);border-radius: 1vw;" @click="controlKNumber">关键数据</div>
        </div>
        <div class="banner-bottom">
          <a @click="playerVideo(ceoVideo,'home')" target="_blank" class="bannerCeo">
            <img :src="imagesAddressAddressZh+'/shouye-bofang.png'" alt class="jian" />原子链及CEO简介
          </a>
          <router-link to="/details">瞬间爱上原子币</router-link>
          <!-- <a @click="tobps" target="_blank">白皮书</a> -->
          <!-- <a > -->
          <a class="downloadBtn" @click.stop="downloadBtn = !downloadBtn">
            <img :src="imagesAddressAddressZh+'/jian.png'" alt class="jian" />下载APP
              <i class="but3Hovers" v-if="downloadBtn">
                  <p class="atoshi" @click="judgeIp">原子链</p>
                  <p class="detok" @click="huoqu(2)">乐唰</p>
                 <p class="detok" @click="huoqu(99)">原子世界</p>
              </i>

          </a>
        </div>
      </div>

      <div class="content-top" ref="scroll1" id="scroll1">
        <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
        ATOS（原子币）
        <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
      </div>
      <div class="article">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ATOS（原子币） 定位是国与国之间往来支付的加密货币，其理论依据是：诺贝尔经济学奖获得者哈耶克的《货币的非国家化》。
        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ATOS（原子币）是原子链上面价值传递的载体。其技术远景是：每个用户为整个网络贡献空闲算力来获取免费转账服务，
        用户越多算力越多，因而速度越快。将打造成去中心化的操作系统，在原子链网络上你可以通过点击菜单，不需要懂得编程或代码就可以运行智能合约，发代币；开发各种生态应用，
        比如购物，游戏，视频，打车，订机票，订酒店，文件加密，约会网站。现在你在电脑上能干什么，以后在原子链上面就可以干什么。
        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;下载使用相关应用会获得一定的原子币作为积分奖励，原子币可用来打赏、发红包、买商品的时候获得一定的折扣。最终在很多行业中可以作为美元、欧元、比特币、以太坊之外的另一种支付手段，并且有一定的折扣，形成广泛应用，最终成为哈耶克所描叙的具有市场竞争力优势的世界通用货币。
        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ATOS（原子币）规划中的特点：
        <br />
        1、低转账费用：真正的赋能世界，造福人民；
        <br />
        2、秒级支付：用户越多速度越快，POD算法颠覆传统互联网弊病；
        <br />
        3、监管安全：安全实名，符合监管；
        <br />
        4、安全交易：指纹、刷脸识别，高端高效，杜绝造假；
        <br />
        5、操作系统：简单易懂、老少皆宜；
        <br />
        6、智能合约：模块化、菜单化，使用有便捷；
        <br />
        7、1:10000放大机制，福利满满；
        <br />
        8、回购机制、越用越稀有。
        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ATOS（原子币）规划中的应用场景：
        1、原子恋商城：区块链＋社交电商；
        <br />
        2、乐唰短视频：乐唰除了拥有其他热门短视频的娱乐功能以外，乐唰的原子生活里面还囊括了加油、打车、买菜、外卖、高德出行、医药健康、购车票、交电费、特价酒店、看电影，链上版权登记及交易等等生活场景，应有尽有；
        <br />
        3、区块链游戏；这里面是游戏爱好者的乐园，游戏充值还送原子币通证；
        <br />
        4、社交聊天软件；
        <br />
        5、链上版权签证（目前链上许愿，爱情、婚姻鉴证只是很小一部分功能）；
        <br />
        6、原子基金投资；
        <br />
        7、原子链公链：将作为基础公链，服务于各行各业；
        <br />
        8、原子链交易所：国际数字资产交易所；
        <br />
        <span v-show="newAdd">
        9、原子链国际支付系统：通俗的讲就是未来的国际支付宝，将架起一座通向世界各国的金融桥梁。
        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;目前，ATOS（原子币）依然是免费赠送模式，属于行为挖矿，手机挖矿模式。推荐用户下载APP，邀请方和被邀请方都可以免费获赠一定数量的原子币和原力。原力代表手机挖矿的效率，原力越高，每次登录APP挖矿奖励越高。用户体量已经达到1200余万人，日启动次数最高达到950万人次，已成为区块链赋能实体的典范，web3的领军项目。
        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;原子币规划将拥有比特币和黄金的优点，改良比特币和黄金的部分缺点，且拥有实际的应用场景和跟日常生活场景相融合。比特币增值2600万倍，原子币在比特币等优秀加密货币的基础上进行进一步的升级，青出于蓝而胜于蓝，目标比较宏大；区块链领域将出现一个比现有最大型的公司规模大10倍的公司，原子链正往这个方向努力。
        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ATOS（原子币）生态的发展历程：
        <br />
        1、2018年4月成立开曼原子基金有限公司并在迪拜发行原子币；
        <br />
        2、2018年11月6日央视主持人李雨霏采访廖望并录制节目《小原子也可以点亮世界》；
        <br />
        3、2018年11月30日，CEO廖望在世界第一屏“纳斯达克大屏幕”向世界宣布“给世界赋能”；
        <br />
        4、2019年1月12日，在第四节“中国经济新模式创新与发展峰会”上，CEO廖望斩获区块链行业“十大创新企业家大奖”；
        <br />
        5、2019 年 5 月 25 号，原子恋商城APP上线，注册推广双方各赠送1000枚原子币；
        <br />
        6、2020年1月3日，原子币生态——原子链商城获得六项国家版权局颁发的软件著作权证书；
        <br />
        7、2020年1月19日，原子币生态团队年会盛典隆重举行，300万用户激情点燃；
        <br />
        8、2020年10月26日，CEO廖望签署战略协议，陆续斥资一亿元人民币进军分布式存储领域；
        <br />
        9、2021年3月27日-29日， CEO廖望荣获“2020中国经济新锐人物”奖项；
        <br />
        10、2021年10月21日，CEO廖望参加中国通信委员会区块链专委会主办的“1024区块链活动日”，发表重要言论“世界是你的，也是我的，最后都是玩区块链的”；
        <br />
        11、2022年1月28日，原子链公链研发迈出坚实一步，进入内测阶段；
        <br />
        12、2022年2月份，原子链APP原子币同比例放大100倍，总量达到10万亿枚；以太坊链上的原子币依然保持1000亿枚；
        <br />
        13、2022年6月，代表原子币产生效率的原力迎来第一轮大衰减；
        <br />
        14、2022年8月份，原子币拥有用户突破千万大关；
        <br />
        15、2022年10月，CEO廖望被聘为萨尔瓦多驻华大使馆特邀区块链行业顾问；
        <br />
        16、2023年4月28日，原子币IMFO成员首届大型见面会在海南博鳌亚洲湾举行；
        <br />
        17、2023年5月中旬，原子币进入通缩时代，回收的币超过送出去的币；
        <br />
        18、2023年5月25日，承载着原子币应用的原子链APP国内上线四周年庆典在云南昆明、大理隆重举行；
        <br />
        19、2023年6月6日，CEO廖望被北京赣州企业商会授予“社会责任奖”；
        <br />
        20、2023年8月16日，京忠智库主席王京忠一行到访原子链原子币生态，参观指导工作；CEO廖望被誉为中国未来的马斯克；
        <br />
        21、2023年8月31日，廖望受邀参加第十八届长春电影节，获得优秀出品人奖；
        <br />
        22、2023年9月27日，廖望携手北京公益发展促进会，向河北涿州塔照中心小营小学捐赠一所图书馆；
        <br />
        23、2023年10月初，廖望受邀参加母校兴国平川中学百年校庆，并成立“谢远谱-廖望奖学金”，向50位优秀学子发放奖学金；
        <br />
        24、2023年10月，廖望被聘为中国管理科学研究院人才教育培训中心首席客座教授。
        </span>
    </div>
      <div class="more" @click="newAdd = !newAdd" v-show="!newAdd">
        <button>更多</button>
      </div>
      <div class="more" @click="newAdd = !newAdd" v-show="newAdd">
        <button>收起</button>
      </div>

      <div class="content-top" ref="scroll1" id=" scroll1">
        <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
        为什么选择原子币
        <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
      </div>
      <div class="article">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;原子币定位是国与国之间往来支付的加密货币，其理论依据是，诺贝尔经济学奖获得者哈耶克的《货币的非国家化》。
        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们认为世界要更美好，每个主权国家就应该稳定繁荣。
        国家要有货币发行权，这是神圣不可侵犯的，这样政府才能调控经济，调动社会资源，把国家建设的更好。
        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;但是国家与国家之间的往来，现在还没有一种值得信赖货币，只能用美元，于是产生了美元霸权。国与国之间支付的货币不应该由某一个国家发，然后收取别的国家铸币税。这种货币应该由区块链技术发行，由世界人民自己掌握。原子链正往这个方向努力。
        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;如果每个行业都可以使用原子币支付，原子币的应用场景将会非常广阔，从而被国际认可，成为一种国家之间可以自由使用、秒级到账、不可增发的优势货币。原子币将努力打造以下核心特点：
        <br />
      </div>
      <div class="six">
        <div class="six-odd">
          <div
            class="odd"
            v-for="(item, index) in odd"
            :key="index"
            @click="onClick(index)"
          >
            <div class="odd-img">
              <img :src="item.img" alt />
            </div>
            <div class="odd-font">{{ item.title }}</div>
          </div>
        </div>
        <div class="six-odd six-odd-Carousel">
          <div
            class="odds"
            v-for="(item, index) in odds"
            :key="index"
            style="display: flex; align-items: center"
          >
            <!-- <p v-if="index==7">
              <img src="../assets_ch/six/t7_7.png" />
            </p> -->
            <!-- <p v-else>{{ item.content }}</p> -->
            <p>{{ item.content }}</p>
          </div>
        </div>
      </div>
      <div class="content-top" ref="scroll2">
        <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
        原子币是怎么保值和增值的？
        <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
      </div>
      <div class="introduction">
        <img :src="imagesAddressAddressZh+'/zengzhi4.png'" alt />
      </div>

      <div class="content-top" ref="scroll9">
        <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
        如何获取原子币？
        <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
      </div>
      <div class="article">
        <p>
          <!--原子币增长万倍的潜力，但同时需要您的呵护支持。您的助力让国际支付更有效率，提高社会生产力，解决金融不平等，为中国梦加油。您伟大的支持，我们将回馈丰厚的物质回报，月收入1万+不是梦想，奔驰特斯拉开回家......赶快获取原子币，参与社会变革吧。-->
          区块链将改变世界，赶紧参与社会变革吧。
        </p>
      </div>
      <div style="padding: 0px 10px">
        <img :src="imagesAddressAddressZh+'/img/atoshi_store.png'" style="width: 100%" alt />
        <div style="width: 100%; text-align: center">原子恋商城</div>
        <div style="text-align: center">
          <button
            @click="huoqu(1)"
            style="
              background: #00a0ea;
              color: #ffffff;
              padding: 4px 12px;
              border-radius: 6px;
              margin-top: 0.2rem;
              height: 27px;
              font-size: 12px;
              transform: scale(0.9);
            "
          >
            点击进入
          </button>
        </div>
      </div>
      <div
        style="display: flex; justify-content: space-around; margin-top: 10px"
      >
        <div>
          <img
            :src="imagesAddressAddressZh+'/20230629/buy-1.png'"
            style="width: 160px; height: 150px"
            alt
          />
          <div style="width: 150px; text-align: center">
            <span>乐唰短视频</span>
          </div>
          <div style="width: 150px; text-align: center">
            <button
              @click="huoqu(2)"
              style="
                background: #00a0ea;
                color: #ffffff;
                padding: 4px 12px;
                border-radius: 6px;
                margin-top: 0.2rem;
                height: 27px;
                font-size: 12px;
                transform: scale(0.9);
              "
            >
              点击进入
            </button>
          </div>
        </div>
        <div>
          <img
            :src="imagesAddressAddressZh+'/img/buy-2.png'"
            style="width: 160px; height: 150px"
            alt
          />
          <div style="width: 150px; text-align: center">
            <span>原子链游戏</span>
          </div>
          <div style="width: 150px; text-align: center">
            <button
              @click="huoqu(3)"
              style="
                background: #00a0ea;
                color: #ffffff;
                padding: 4px 12px;
                border-radius: 6px;
                margin-top: 0.2rem;
                height: 27px;
                font-size: 12px;
                transform: scale(0.9);
              "
            >
              点击进入
            </button>
          </div>
        </div>
      </div>
      <div
        style="display: flex; justify-content: space-around; margin-top: 10px"
      >
        <div>
          <img
           :src="imagesAddressAddressZh+'/img/buy-3.png'"
            style="width: 160px; height: 150px"
            alt
          />
          <div style="width: 150px; text-align: center">
            <span>币币兑换</span>
          </div>
          <div style="width: 150px; text-align: center">
            <button
              style="
                background: rgb(204, 204, 204);
                color: #ffffff;
                padding: 4px 12px;
                border-radius: 6px;
                margin-top: 0.2rem;
                height: 27px;
                font-size: 12px;
                transform: scale(0.9);
                width: 125px;
                position: relative;
                left: -5px;
              "
            >
              不对中国大陆开放
            </button>
          </div>
        </div>
        <div>
          <img
            :src="imagesAddressAddressZh+'/img/buy-4.png'"
            style="width: 160px; height: 150px"
            alt
          />
          <div style="width: 150px; text-align: center">
            <span>场外获取</span>
          </div>
          <div style="width: 150px; text-align: center">
            <button
              style="
                background: rgb(204, 204, 204);
                color: #ffffff;
                padding: 4px 12px;
                border-radius: 6px;
                margin-top: 0.2rem;
                height: 27px;
                font-size: 12px;
                transform: scale(0.9);
              "
            >
              暂不开放
            </button>
          </div>
        </div>
      </div>
      <!--<ul class="huoqu" style="display: inline-block; text-align: center;">-->
      <!--<li class="left" style>-->
      <!--<img src="../assets_ch/huoqu1.png" style="width: 100%" alt />-->
      <!--<button-->
      <!--@click="huoqu(2)"-->
      <!--style="background:#00A0EA;color:#FFFFFF;padding:4px 12px;border-radius: 6px;margin-top:0.2rem;height:27px;font-size:12px;transform: scale(0.9);"-->
      <!--&gt;点击进入</button>-->
      <!--</li>-->
      <!--<li class="left" style>-->
      <!--<img src="../assets_ch/huoqu2.png" style="width: 100%" alt />-->
      <!--&lt;!&ndash;<button&ndash;&gt;-->
      <!--&lt;!&ndash;@click="huoqu(1)"&ndash;&gt;-->
      <!--&lt;!&ndash;style="background:#00A0EA;color:#FFFFFF;padding:4px 12px;border-radius: 6px;margin-top:0.2rem"&ndash;&gt;-->
      <!--&lt;!&ndash;&gt;点击进入</button>&ndash;&gt;-->
      <!--<button-->
      <!--style="background:rgb(204,204,204);color:#FFFFFF;padding:4px 12px;border-radius: 6px;margin-top:0.2rem;height:27px;font-size:12px;transform: scale(0.9);width:125px;position:relative;left:-5px;"-->
      <!--&gt;不对中国大陆开放</button>-->
      <!--</li>-->
      <!--<li class="left" style>-->
      <!--<img src="../assets_ch/huoqu3.png" style="width: 100%" alt />-->
      <!--<button-->
      <!--style="background:rgb(204,204,204);color:#FFFFFF;padding:4px 12px;border-radius: 6px;margin-top:0.2rem;height:27px;font-size:12px;transform: scale(0.9);"-->
      <!--&gt;暂不开放</button>-->
      <!--</li>-->
      <!--</ul>-->

      <div class="content-top" ref="scroll3">
        <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
        ATOS的应用场景
        <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
      </div>
      <div class="session1">
        一、正在和已落地应用（请
        <a @click="judgeIp">下载APP</a>进行体验）
      </div>
      <!--<el-carousel-->
      <!--style="height:200px;overflow:hidden; margin:20px 0;"-->
      <!--indicator-position="none"-->
      <!--:autoplay="false"-->
      <!--arrow="always"-->
      <!--&gt;-->
      <!--<el-carousel-item style="height:200px">-->
      <!--<img style="width:45%" :src="img1" alt>-->
      <!--<img style="width:45%" :src="img2" alt>-->
      <!--</el-carousel-item>-->
      <!--<el-carousel-item style="height:200px">-->
      <!--<img style="width:45%" :src="img3" alt>-->
      <!--<img style="width:45%" :src="img4" alt>-->
      <!--</el-carousel-item>-->
      <!--<el-carousel-item style="height:200px">-->
      <!--<img style="width:45%" :src="img5" alt>-->
      <!--<img style="width:45%" :src="img6" alt>-->
      <!--</el-carousel-item>-->
      <!--</el-carousel>-->
      <div class="changjing1_box">
        <img :src="imagesAddressAddressZh+'/changjing1_img.png'" class="changjing1_img" />
        <div class="changjing1_top_text_box">
          <img :src="imagesAddressAddressZh+'/zuoyinhao.png'" class="zuoyinhao" />
          <div class="changjing1_top_text">
            目前主抓落地项目：原子链。用区块链赋能社交电商，APP每日启动峰值超过960万次，商城每日付款突破40000笔，每日活跃用户峰值超过百万；商城有以下特点
            ：
          </div>
          <img :src="imagesAddressAddressZh+'/youyinhao.png'" class="youyinhao" />
        </div>
      </div>
      <div class="changjing1_bott">
        <div class="changjing1_bott_left_box">
          <div class="changjing1_bott_left_text1 changjing1_bott_left_text">
            与淘宝天猫京东拼多多合作，我们的用户通过我们的APP去以上商城购物将享受一定的优惠，省钱买到同样的产品，我们也会得到上面平台的返佣；同时用户还可以获赠原子币。目前我们有1000多万注册用户，平均每个客户在以上平台消费后，我们获得淘宝天猫京东拼多多返佣1块钱，就是每天1000多万日收入<br />
            <img :src="imagesAddressAddressZh+'/img/application_tao.png'" />
          </div>
          <div class="changjing1_bott_left_text2 changjing1_bott_left_text">
            买家买产品免费得币，币升值潜力无限，从单纯消费者转换成潜力赚钱者，鼓励消费拉升GDP<br />
            <img :src="imagesAddressAddressZh+'/img/application_buy.png'" />
          </div>
          <div class="changjing1_bott_left_text3 changjing1_bott_left_text">
            将实现商家入驻，人人可免费开店，帮助卖家去库存，拉升GDP<br />
            <img :src="imagesAddressAddressZh+'/img/application_free.png'" />
          </div>
        </div>
        <div class="changjing1_bott_zhong_box">
          <span class="shutiao"></span>
          <img
            :src="imagesAddressAddressZh+'/xiaoyuandian.png'"
            class="xiaoyuandian1 xiaoyuandian"
          />
          <img
            :src="imagesAddressAddressZh+'/xiaoyuandian.png'"
            class="xiaoyuandian2 xiaoyuandian"
          />
          <img
            :src="imagesAddressAddressZh+'/xiaoyuandian.png'"
            class="xiaoyuandian3 xiaoyuandian"
          />
          <img
            :src="imagesAddressAddressZh+'/xiaoyuandian.png'"
            class="xiaoyuandian4 xiaoyuandian"
          />
          <img
            :src="imagesAddressAddressZh+'/xiaoyuandian.png'"
            class="xiaoyuandian5 xiaoyuandian"
          />
          <img
            :src="imagesAddressAddressZh+'/xiaoyuandian.png'"
            class="xiaoyuandian6 xiaoyuandian"
          />
        </div>
        <div class="changjing1_bott_right_box">
          <div class="changjing1_bott_right_text1 changjing1_bott_right_text">
            在家也能创业：通过分享APP，把闲散时间变成生产力；只要努力，月收入可能超过万元！<br />
            <img :src="imagesAddressAddressZh+'/img/application_help.png'" />
          </div>
          <div class="changjing1_bott_right_text2 changjing1_bott_right_text">
            分享补贴家用：多劳多得，把财富给到劳动者手中！<br />
            <img :src="imagesAddressAddressZh+'/img/application_share.png'" />
          </div>
          <div class="changjing1_bott_right_text3 changjing1_bott_right_text">
            当原子链用户达到2000万以后，我们会筹划开交易所，原子币将作为交易所的平台币，持有原子币交易手续费可以打折，用原子币支付手续费可以打折，上币投票也需要使用原子币；交易所的手续费也将用来回购原子币。<br />
            <img :src="imagesAddressAddressZh+'/img/application_jys.png'" />
          </div>
        </div>
      </div>
      <div class="session2">二、原子链 APP里的其他落地应用：</div>
      <div class="application" style="margin-bottom: 0.4rem">
        <!-- 1 -->
        <div class="application-two">
          <div class="three-left">
            <img :src="imagesAddressAddressZh+'/20230629/otheryingyong_img1.jpg'" alt />
          </div>
          <div class="three-right" style="font-size: 0.24rem">
            <p>
              乐唰短视频<span @click="huoqu(2)"
                ><img :src="imagesAddressAddressZh+'/downArrow.png'" />下载</span
              >
            </p>
            <p @click="iszhankai(0)">
              {{
                otheryingyongtexts[0].iszhankai
                  ? otheryingyongtexts[0].text2
                  : otheryingyongtexts[0].text
              }}
              <template v-if="otheryingyongtexts[0].text.length > 36">
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="zhankai"
                  @click.stop="iszhankai(0)"
                  v-if="!otheryingyongtexts[0].iszhankai"
                />
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="shouqi"
                  @click.stop="iszhankai(0)"
                  v-else
                />
              </template>
            </p>
          </div>
        </div>
        <!-- 2 -->
        <div class="application-two">
          <div class="three-right three-r" style="font-size: 0.24rem">
            <p>
              原子链游戏<span @click="huoqu(3)"
                ><img :src="imagesAddressAddressZh+'/downArrow.png'" />下载</span
              >
            </p>
            <p @click="iszhankai(2)">
              {{
                otheryingyongtexts[2].iszhankai
                  ? otheryingyongtexts[2].text2
                  : otheryingyongtexts[2].text
              }}
              <template v-if="otheryingyongtexts[2].text.length > 36">
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="zhankai"
                  @click.stop="iszhankai(2)"
                  v-if="!otheryingyongtexts[2].iszhankai"
                />
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="shouqi"
                  @click.stop="iszhankai(2)"
                  v-else
                />
              </template>
            </p>
          </div>
          <div class="three-left three-l">
            <img :src="imagesAddressAddressZh+'/otheryingyong_img3.png'" alt />
          </div>
        </div>
        <!-- 3 -->
        <div class="application-two">
          <div class="three-left">
            <img :src="imagesAddressAddressZh+'/20230629/otheryingyong_img9.jpg'" alt />
          </div>
          <div class="three-right" style="font-size: 0.24rem">
            <p>
              原子链钱包<span @click="huoqu(9)"
                ><img :src="imagesAddressAddressZh+'/downArrow.png'" />下载</span
              >
            </p>
            <p @click="iszhankai(9)">
              {{
                otheryingyongtexts[9].iszhankai
                  ? otheryingyongtexts[9].text2
                  : otheryingyongtexts[9].text
              }}
              <template v-if="otheryingyongtexts[9].text.length > 36">
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="zhankai"
                  @click.stop="iszhankai(9)"
                  v-if="!otheryingyongtexts[9].iszhankai"
                />
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="shouqi"
                  @click.stop="iszhankai(9)"
                  v-else
                />
              </template>
            </p>
          </div>
        </div>
        <!-- 4 -->
        <div class="application-two">
          <div class="three-right three-r" style="font-size: 0.24rem">
            <p style="font-size: 0.24rem">
              原宇宙<span @click="huoqu(10)"
                ><img :src="imagesAddressAddressZh+'/downArrow.png'" />下载</span
              >
            </p>
            <p @click="iszhankai(10)">
              {{
                otheryingyongtexts[10].iszhankai
                  ? otheryingyongtexts[10].text2
                  : otheryingyongtexts[10].text
              }}
              <template v-if="otheryingyongtexts[10].text.length > 36">
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="zhankai"
                  @click.stop="iszhankai(10)"
                  v-if="!otheryingyongtexts[10].iszhankai"
                />
                <img
                 :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="shouqi"
                  @click.stop="iszhankai(10)"
                  v-else
                />
              </template>
            </p>
          </div>
          <div class="three-left three-l">
            <img :src="imagesAddressAddressZh+'/20230629/otheryingyong_img10.jpg'" alt />
          </div>
        </div>
        <!-- 5-->
        <div class="application-two">
          <div class="three-left">
            <img :src="imagesAddressAddressZh+'/otheryingyong_img9.jpg'" alt />
          </div>
          <div class="three-right">
            <p style="font-size: 0.24rem">
              原子链区块浏览器
              <span @click="huoqu(5)">前往体验</span>
            </p>
            <p @click="iszhankai(8)">
              {{
                otheryingyongtexts[8].iszhankai
                  ? otheryingyongtexts[8].text2
                  : otheryingyongtexts[8].text
              }}
              <template v-if="otheryingyongtexts[8].text2.length > 36">
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="zhankai"
                  @click.stop="iszhankai(8)"
                  v-if="!otheryingyongtexts[8].iszhankai"
                />
                <img
                 :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="shouqi"
                  @click.stop="iszhankai(8)"
                  v-else
                />
              </template>
            </p>
          </div>
        </div>
        <!-- 6 -->
        <div class="application-two">
          <div class="three-right three-r" style="font-size: 0.24rem">
            <p style="font-size: 0.24rem">
              原子链国际版<span @click="huoqu(4)"
                ><img :src="imagesAddressAddressZh+'/downArrow.png'" />下载</span
              >
            </p>
            <p @click="iszhankai(4)">
              {{
                otheryingyongtexts[4].iszhankai
                  ? otheryingyongtexts[4].text2
                  : otheryingyongtexts[4].text
              }}
              <template v-if="otheryingyongtexts[4].text.length > 36">
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="zhankai"
                  @click.stop="iszhankai(4)"
                  v-if="!otheryingyongtexts[4].iszhankai"
                />
                <img
                 :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="shouqi"
                  @click.stop="iszhankai(4)"
                  v-else
                />
              </template>
            </p>
          </div>
          <div class="three-left three-l">
            <img :src="imagesAddressAddressZh+'/otheryingyong_img6.png'" alt />
          </div>
        </div>
        <!-- 7 -->
        <div class="application-two">
          <div class="three-left">
            <img :src="imagesAddressAddressZh+'/20230629/otheryingyong_img11.jpg'" alt />
          </div>
          <div class="three-right" style="font-size: 0.24rem">
            <p>
              原子密码箱<span @click="huoqu(11)"
                ><img :src="imagesAddressAddressZh+'/downArrow.png'" />下载</span
              >
            </p>
            <p @click="iszhankai(11)">
              {{
                otheryingyongtexts[11].iszhankai
                  ? otheryingyongtexts[11].text2
                  : otheryingyongtexts[11].text
              }}
              <template v-if="otheryingyongtexts[11].text.length > 36">
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="zhankai"
                  @click.stop="iszhankai(11)"
                  v-if="!otheryingyongtexts[11].iszhankai"
                />
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="shouqi"
                  @click.stop="iszhankai(11)"
                  v-else
                />
              </template>
            </p>
          </div>
        </div>
        <!-- 8 -->
        <div class="application-two">
          <div class="three-right three-r" style="font-size: 0.24rem">
            <p>
                小原子早晚安
                <span @click="huoqu(12)">扫码体验</span>
            </p>
            <p @click="iszhankai(12)">
              {{
                otheryingyongtexts[12].iszhankai
                  ? otheryingyongtexts[12].text2
                  : otheryingyongtexts[12].text
              }}
              <template v-if="otheryingyongtexts[12].text.length > 36">
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="zhankai"
                  @click.stop="iszhankai(12)"
                  v-if="!otheryingyongtexts[12].iszhankai"
                />
                <img
                 :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="shouqi"
                  @click.stop="iszhankai(12)"
                  v-else
                />
              </template>
            </p>
          </div>
          <div class="three-left three-l">
            <img :src="imagesAddressAddressZh+'/20230629/otheryingyong_img12.jpg'" alt />
          </div>
        </div>
        <!-- 9 -->
        <div class="application-two">
          <div class="three-left">
            <img :src="imagesAddressAddressZh+'/20230629/otheryingyong_img13.jpg'" alt />
          </div>
          <div class="three-right" style="font-size: 0.24rem">
            <p>
                原子链AI
                <span @click="huoqu(13)">扫码体验</span>
            </p>
            <p @click="iszhankai(13)">
              {{
                otheryingyongtexts[13].iszhankai
                  ? otheryingyongtexts[13].text2
                  : otheryingyongtexts[13].text
              }}
              <template v-if="otheryingyongtexts[13].text.length > 36">
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="zhankai"
                  @click.stop="iszhankai(13)"
                  v-if="!otheryingyongtexts[13].iszhankai"
                />
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="shouqi"
                  @click.stop="iszhankai(13)"
                  v-else
                />
              </template>
            </p>
          </div>
        </div>
        <!-- 10 -->
        <div class="application-two">
          <div class="three-right three-r">
            <p>链上鉴证
                <span @click="judgeIp"><img :src="imagesAddressAddressZh+'/downArrow.png'" />下载</span>
            </p>
            <p @click="iszhankai(1)">
              {{
                otheryingyongtexts[1].iszhankai
                  ? otheryingyongtexts[1].text2
                  : otheryingyongtexts[1].text
              }}
              <template v-if="otheryingyongtexts[1].text.length > 36">
                <img
                 :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="zhankai"
                  @click.stop="iszhankai(1)"
                  v-if="!otheryingyongtexts[1].iszhankai"
                />
                <img
                 :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="shouqi"
                  @click.stop="iszhankai(1)"
                  v-else
                />
              </template>
            </p>
          </div>
          <div class="three-left three-l" style="font-size: 0.24rem">
            <img :src="imagesAddressAddressZh+'/otheryingyong_img2.png'" alt />
          </div>
        </div>
        <!-- 11 -->
        <div class="application-two">
          <div class="three-left">
            <img :src="imagesAddressAddressZh+'/otheryingyong_img4.png'" alt />
          </div>
          <div class="three-right" style="font-size: 0.24rem">
            <p>
                原子生活
                <span @click="judgeIp"><img :src="imagesAddressAddressZh+'/downArrow.png'" />下载</span>
            </p>
            <p @click="iszhankai(3)">
              {{
                otheryingyongtexts[3].iszhankai
                  ? otheryingyongtexts[3].text2
                  : otheryingyongtexts[3].text
              }}
              <template v-if="otheryingyongtexts[13].text.length > 36">
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="zhankai"
                  @click.stop="iszhankai(3)"
                  v-if="!otheryingyongtexts[3].iszhankai"
                />
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="shouqi"
                  @click.stop="iszhankai(3)"
                  v-else
                />
              </template>
            </p>
          </div>
        </div>
        <!-- 12 -->
        <div class="application-two">
         <div class="three-right three-r">
            <p>将研发聊天软件</p>
            <p @click="iszhankai(6)">
              {{
                otheryingyongtexts[6].iszhankai
                  ? otheryingyongtexts[6].text2
                  : otheryingyongtexts[6].text
              }}
              <template v-if="otheryingyongtexts[6].text.length > 36">
                <img
                 :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="zhankai"
                  @click.stop="iszhankai(6)"
                  v-if="!otheryingyongtexts[6].iszhankai"
                />
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="shouqi"
                  @click.stop="iszhankai(6)"
                  v-else
                />
              </template>
            </p>
          </div>
          <div class="three-left" style="font-size: 0.24rem">
            <img :src="imagesAddressAddressZh+'/otheryingyong_img8.png'" alt />
          </div>
        </div>
        <!-- 13 -->
        <div class="application-two">
          <div class="three-left">
            <img :src="imagesAddressAddressZh+'/otheryingyong_img5.png'" alt />
          </div>
          <div class="three-right">
            <p>其他</p>
            <p @click="iszhankai(7)">
              {{
                otheryingyongtexts[7].iszhankai
                  ? otheryingyongtexts[7].text2
                  : otheryingyongtexts[7].text
              }}
              <template v-if="otheryingyongtexts[7].text.length > 36">
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="zhankai"
                  @click.stop="iszhankai(7)"
                  v-if="!otheryingyongtexts[7].iszhankai"
                />
                <img
                 :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="shouqi"
                  @click.stop="iszhankai(7)"
                  v-else
                />
              </template>
            </p>
          </div>
        </div>
      </div>
      <div class="session2">三、远期规划应用</div>
      <!--<div class="title-blue">-->
      <!--<div class="title-left"></div>-->
      <!--<div class="title-font">线上</div>-->
      <!--</div>-->
      <div class="application">
        <div class="application-three">
          <div class="three-left">
            <img :src="imagesAddressAddressZh+'/no.1.jpg'" alt />
          </div>
          <div class="three-right">
            <p>NO.1</p>
            <p @click="iszhankai2(0)">
              {{
                yuanqiguihuatexts[0].iszhankai
                  ? yuanqiguihuatexts[0].text2
                  : yuanqiguihuatexts[0].text
              }}
              <template v-if="yuanqiguihuatexts[0].text.length > 38">
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="zhankai"
                  @click.stop="iszhankai2(0)"
                  v-if="!yuanqiguihuatexts[0].iszhankai"
                />
                <img
                 :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="shouqi"
                  @click.stop="iszhankai2(0)"
                  v-else
                />
              </template>
            </p>
          </div>
        </div>
        <div class="application-three">
          <div class="three-right three-r">
            <p>NO.2</p>
            <p>{{ yuanqiguihuatexts[1].text2 }}</p>
          </div>
          <div class="three-left three-l">
            <img :src="imagesAddressAddressZh+'/no.2.jpg'" alt />
          </div>
        </div>
        <div class="application-three">
          <div class="three-left">
            <img :src="imagesAddressAddressZh+'/no.3.jpg'" alt />
          </div>
          <div class="three-right">
            <p>NO.3</p>
            <p @click="iszhankai2(2)">
              {{
                yuanqiguihuatexts[2].iszhankai
                  ? yuanqiguihuatexts[2].text2
                  : yuanqiguihuatexts[2].text
              }}
              <template v-if="yuanqiguihuatexts[2].text.length > 38">
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="zhankai"
                  @click.stop="iszhankai2(2)"
                  v-if="!yuanqiguihuatexts[2].iszhankai"
                />
                <img
                  :src="imagesAddressAddressZh+'/zhankai.png'"
                  class="shouqi"
                  @click.stop="iszhankai2(2)"
                  v-else
                />
              </template>
            </p>
          </div>
        </div>
        <span v-show="sixShow">
          <div class="application-three">
            <div class="three-right three-r">
              <p>NO.4</p>
              <p @click="iszhankai2(3)">
                {{
                  yuanqiguihuatexts[3].iszhankai
                    ? yuanqiguihuatexts[3].text2
                    : yuanqiguihuatexts[3].text
                }}
                <template v-if="yuanqiguihuatexts[3].text.length > 38">
                  <img
                    :src="imagesAddressAddressZh+'/zhankai.png'"
                    class="zhankai"
                    @click.stop="iszhankai2(3)"
                    v-if="!yuanqiguihuatexts[3].iszhankai"
                  />
                  <img
                    :src="imagesAddressAddressZh+'/zhankai.png'"
                    class="shouqi"
                    @click.stop="iszhankai2(3)"
                    v-else
                  />
                </template>
              </p>
            </div>
            <div class="three-left three-l">
              <img :src="imagesAddressAddressZh+'/no.4.jpg'" alt />
            </div>
          </div>
          <div class="application-three">
            <div class="three-left">
              <img :src="imagesAddressAddressZh+'/no.5.jpg'" alt />
            </div>
            <div class="three-right">
              <p>NO.5</p>
              <p @click="iszhankai2(4)">
                {{
                  yuanqiguihuatexts[4].iszhankai
                    ? yuanqiguihuatexts[4].text2
                    : yuanqiguihuatexts[4].text
                }}
                <template v-if="yuanqiguihuatexts[4].text.length > 38">
                  <img
                    :src="imagesAddressAddressZh+'/zhankai.png'"
                    class="zhankai"
                    @click.stop="iszhankai2(4)"
                    v-if="!yuanqiguihuatexts[4].iszhankai"
                  />
                  <img
                    :src="imagesAddressAddressZh+'/zhankai.png'"
                    class="shouqi"
                    @click.stop="iszhankai2(4)"
                    v-else
                  />
                </template>
              </p>
            </div>
          </div>
          <div class="application-three">
            <div class="three-right three-r">
              <p>NO.6</p>
              <p @click="iszhankai2(5)">
                {{
                  yuanqiguihuatexts[5].iszhankai
                    ? yuanqiguihuatexts[5].text2
                    : yuanqiguihuatexts[5].text
                }}
                <template v-if="yuanqiguihuatexts[5].text.length > 38">
                  <img
                    :src="imagesAddressAddressZh+'/zhankai.png'"
                    class="zhankai"
                    @click.stop="iszhankai2(5)"
                    v-if="!yuanqiguihuatexts[5].iszhankai"
                  />
                  <img
                    :src="imagesAddressAddressZh+'/zhankai.png'"
                    class="shouqi"
                    @click.stop="iszhankai2(5)"
                    v-else
                  />
                </template>
              </p>
            </div>
            <div class="three-left three-l">
              <img :src="imagesAddressAddressZh+'/no.6.jpg'" alt />
            </div>
          </div>
          <!-- <div class="session2" style="margin-top:0.7rem;">四、我们提供的技术服务</div>
          <div>
            <img src="../assets_ch/fuwus_img1.png" style="width:100%;" />
          </div> -->
        </span>
      </div>
      <!--<span v-show="sixShow">-->
      <!--<div class="title-blue" style="margin-top:.2rem;">-->
      <!--<div class="title-left"></div>-->
      <!--<div class="title-font">线下</div>-->
      <!--</div>-->
      <!--<div class="xxi">-->
      <!--<div class="xxi-i">-->
      <!--<img src="../assets_ch/xianxia1.jpg" alt>-->
      <!--</div>-->
      <!--<div-->
      <!--class="xxi-f"-->
      <!--&gt;由于我们的CEO在迪拜有自己的房产公司，叫迪拜原子能房产，是迪拜华人最大的房产公司。成立于2009年，迪拜房地产资源特别丰富。利用迪拜10年来累积的资源，我们原子币的应用场景会从买房开始，跟迪拜各大开发商合作，用原子币支付买房，随后二手房逐步开放。然后用原子币可以打折消费，比如去迪拜的餐馆，游艇，酒店都可以用原子币支付，只要用原子币支付买单可以打7折或者其他折扣。迪拜部署完了，我们再去美国，去欧洲一样复制部署应用场景。让全世界买房和用原子币打折消费。</div>-->
      <!--<div class="xxi-i">-->
      <!--<img src="../assets_ch/xianxia2.jpg" alt>-->
      <!--</div>-->
      <!--<div-->
      <!--class="xxi-f"-->
      <!--&gt;由于我们的CEO在迪拜有自己的房产公司，叫迪拜原子能房产，是迪拜华人最大的房产公司。成立于2009年，迪拜房地产资源特别丰富。利用迪拜10年来累积的资源，我们原子币的应用场景会从买房开始，跟迪拜各大开发商合作，用原子币支付买房，随后二手房逐步开放。然后用原子币可以打折消费，比如去迪拜的餐馆，游艇，酒店都可以用原子币支付，只要用原子币支付买单可以打7折或者其他折扣。迪拜部署完了，我们再去美国，去欧洲一样复制部署应用场景。让全世界买房和用原子币打折消费。</div>-->
      <!--</div>-->
      <!--</span>-->
      <div class="more" @click="sixClick()" v-show="sixS">
        <button>更多</button>
      </div>
      <div class="more" @click="sixClicks()" v-show="sixSs">
        <button>收起</button>
      </div>

      <div class="content-top" ref="scroll11" id="scroll11">
        <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
        原子链的发展历程
        <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
      </div>
      <div class="article">
        1、2018年4月成立开曼原子基金有限公司并在迪拜发起原子链项目，并且发行了原子链的代币原子币。
        <br />
        2、2018年11月6日央视主持人李雨霏采访廖望并录制节目《小原子也可以点亮世界》；
        <br />
        3、2018年11月30日，CEO廖望在世界第一屏“纳斯达克大屏幕”向世界宣布“给世界赋能”；
        <br />
        4、2019年1月12日，在第四节“中国经济新模式创新与发展峰会”上，CEO廖望斩获区块链行业“十大创新企业家大奖”；
        <br />
        5、2019 年 5 月 25 号，原子恋商城APP上线；
        <br />
        6、2020年1月3日，原子恋商城获得六项国家版权局颁发的软件著作权证书；
        <br />
        7、2020年1月19日，原子链生态团队年会盛典隆重举行，在线播放超过450万人次；
        <br />
        8、2020年10月26日，CEO廖望签署战略协议，斥资一亿元人民币进军分布式存储领域；
        <br />
        9、2021年3月27日-29日， CEO廖望荣获“2020中国经济新锐人物”奖项；
        <br />
        10、2021年10月21日，CEO廖望参加中国通信委员会区块链专委会主办的“1024区块链活动日”，发表重要言论“世界是你的，也是我的，最后都是玩区块链的”。
        <br />
        11、2022年1月28日，原子链公链研发迈出坚实一步，进入内测阶段；
        <br />
        12、2022年2月份，原子链APP原子币同比例放大100倍，总量达到10万亿枚，并将在主网上线再次扩大100倍，总量达到1000万亿枚；以太坊链上的原子币依然保持1000亿枚，将在主网上线后直接扩大10000倍，以保持总量1000万亿枚
        <br />
        13、2022年6月，代表原子币产生效率的原力迎来第一轮大衰减；
        <br />
        14、2022年8月份，原子链拥有用户突破千万大关；
        <br />
        15、2022年10月，CEO廖望被聘为萨尔瓦多驻华大使馆特邀区块链行业顾问；
        <br />
        16、2023年4月28日，原子链IMFO成员首届大型见面会在海南博鳌亚洲湾举行；
        <br />
        17、2023年5月中旬，原子链进入通缩时代，回收的币超过送出去的币；
        <br />
        18、2023年5月25日，承载着原子链应用的原子链APP国内上线四周年庆典在云南昆明、大理隆重举行；
        <br />
        19、2023年6月6日，CEO廖望被北京赣州企业商会授予“社会责任奖”；
        <br />
        20、2023年8月16日，京忠智库主席王京忠一行到访原子链原子链生态，参观指导工作；CEO廖望被誉为中国未来的马斯克。
        <br />
        21、2023年8月31日，廖望受邀参加第十八届长春电影节并发表主旨演讲，原子链投资项目乐唰将助力短视频发展
        <br />
        22、2023年9月27日，廖望携手北京公益发展促进会，向河北涿州塔照中心小营小学捐赠图书馆并给孩子们分享“如何向着阳光，野蛮生长”。
        <br />
        23、2023年10月初，廖望受邀参加母校兴国平川中学百年校庆，向50位优秀学子发放首批“谢远谱-廖望奖学金”。
        <br />
        24、2023年10月，廖望被聘为中国管理科学研究院人才教育培训中心首席客座教授。
    </div>

      <div class="content-top" ref="scroll4">
        <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
        宣传资料
        <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
      </div>
      <div class="title-blue">
        <div class="title-blue videoFlex">
          <div>
            <div class="title-left"></div>
            <div class="title-font">视频资料</div>
          </div>
          <div class="liaoIntroduction" @click="jumpPerson">
            CEO廖望简介
          </div>
        </div>
      </div>
      <div class="video" style="display: flex; flex-wrap: wrap">
        <!--外来网站资源-->
        <template v-for="(item, index) in video">
          <div class="video-t" v-if="item.externalLink" :key="index">
            <a
              class="video-img"
              style="display: block; position: relative"
              :href="item.externalLink"
            >
              <span
                style="
                  display: inline-block;
                  width: 100%;
                  height: 100%;
                  overflow: hidden;
                  position: relative;
                  z-index: 15;
                  border: 1px solid #ddd;
                  background: #3e3e3e;
                "
              >
                <img
                  :src="item.videoImg"
                  alt
                  style="
                    height: auto;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                  "
                />
              </span>
            </a>
            <div class="video-font" style="text-align: left">
              {{ item.videoTitle }}
            </div>
          </div>
          <!--本地上传视频-->
          <div
            class="video-t"
            v-if="!item.externalLink && item.videoType == 1"
            :data-url="item.readVideoUrl"
            :data-imgurl="item.videoImg"
            :data-videotitle="item.videoTitle"
            :key="index"
            @click="playerVideo(item,'home')"
          >
            <!-- @click="playerVideo(item)" -->
            <div class="video-img" style="position: relative">
              <!-- <video preload='auto' id='my-video'   webkit-playsinline='true' playsinline='true' x-webkit-airplay='true' x5-video-player-type='h5' x5-video-player-fullscreen='true' x5-video-ignore-metadata='true' controls width='100%' height='100%'>
                                            <source :src="item.readVideoUrl">
              </video>-->
              <span
                style="
                  display: inline-block;
                  width: 100%;
                  height: 100%;
                  overflow: hidden;
                  position: relative;
                  z-index: 15;
                  border: 1px solid #ddd;
                  background: #3e3e3e;
                "
              >
                <img
                  :src="item.videoImg"
                  alt
                  style="
                    height: auto;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                  "
                />
              </span>
            </div>
            <div class="video-font" style="text-align: left">
              {{ item.videoTitle }}
            </div>
          </div>
          <div
            style="height: auto"
            class="video-t"
            v-if="item.videoType == 2"
            :key="index"
            @click="playerVideo2(item)"
          >
            <div class="video-img" style="position: relative">
              <!-- <video preload='auto' id='my-video'   webkit-playsinline='true' playsinline='true' x-webkit-airplay='true' x5-video-player-type='h5' x5-video-player-fullscreen='true' x5-video-ignore-metadata='true' controls width='100%' height='100%'>
                                <source :src="item.readVideoUrl">
              </video>-->
              <span
                style="
                  display: inline-block;
                  width: 100%;
                  height: 100%;
                  overflow: hidden;
                  position: relative;
                  z-index: 15;
                  border: 1px solid #ddd;
                  background: #3e3e3e;
                "
              >
                <img
                  :src="item.videoImg"
                  alt
                  style="
                    height: auto;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                  "
                />
              </span>
              <img
                :src="imagesAddressCommon+'/xiangCeBj.png'"
                v-if="item.videoType == 2"
                alt
                style="
                  position: absolute;
                  top: 0px;
                  left: 0px;
                  width: 111%;
                  height: 104%;
                  z-index: 10;
                "
              />
            </div>
            <div class="video-font2" style="text-align: left">
              <h3>{{ item.videoTitle }}</h3>
              <p>共{{ item.videoAccount }}个视频</p>
            </div>
          </div>
        </template>

        <div style="clear: both"></div>
        <div class="more" @click="videoClick()" v-show="!videoShow">
          <button>更多</button>
        </div>
        <div class="more" @click="videoClick()" v-show="videoShow">
          <button>收起</button>
        </div>
      </div>
      <div class="title-blue">
        <div class="title-left"></div>
        <div class="title-font">媒体报道</div>
      </div>
      <div class="video">
        <div
          class="video-t video-tt"
          v-for="(item, index) in news"
          :key="index"
          @click="NewsCli(item.newsLink, item.newsId)"
        >
          <div class="video-img">
            <img :src="item.readCoverImage" alt />
          </div>
          <div class="video-font video-f">
            <p>{{ item.newsTitle | title }}</p>
            <p>{{ item.newsAbstract | content }}</p>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
      <div class="more" @click="newsClick()" v-show="newShow">
        <button>更多</button>
      </div>
      <div class="more" @click="newsClicks()" v-show="newShows">
        <button>收起</button>
      </div>
      <div class="title-blue">
        <div class="title-left"></div>
        <div class="title-font">图片资料</div>
      </div>
      <div class="video video-folder">
        <div
          class="folder enterprise"
          v-for="(item, index) in enterprise"
          :key="index"
          @click="lookPic(item.cultureFolderId)"
        >
          <div class="enterpriseImg">
            <van-image
              width="2.16rem"
              height="2.16rem"
              fit="cover"
              :src="item.folderImgUrl"
            />
          </div>
          <div class="name-describe">
            <h3>{{ item.folderName | title }}</h3>
            <p>{{ item.imgNumber }}张图片</p>
          </div>
        </div>
        <div style="clear: both"></div>
        <div class="more" @click="folderClick()" v-show="!folderShow">
          <button>更多</button>
        </div>
        <div class="more" @click="folderClick()" v-show="folderShow">
          <button>收起</button>
        </div>
      </div>
      <!--音频-->
      <div class="title-blue">
        <div class="title-left"></div>
        <div class="title-font">音频资料</div>
      </div>
      <div class="video audios">
        <div
          class="video-t"
          v-for="(item, index) in audio"
          :key="index"
          @click="audioCli(item)"
          style="height: 3.1rem"
        >
          <div class="video-img">
            <img
              :src="item.readAudioCoverMobile"
              style="width: 2rem; height: 2rem"
              alt
            />
          </div>
          <div class="video-font">
            <h3>{{ item.audioTitle | title }}</h3>
            <p v-if="item.audioType == 1">共{{ item.audioCount }}个音频</p>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
      <div class="more" @click="audioClick()" v-show="audioShow">
        <button>更多</button>
      </div>
      <div class="more" @click="audioClicks()" v-show="audioShows">
        <button>收起</button>
      </div>
      <!--常见问题-->
      <!-- <div class="content-top poTop" ref="scroll5"> -->
      <div class="question" ref="scroll5">
        <a @click="tobps" target="_blank" class="baipishu">白皮书</a>
        <div>
          <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
          <span>常见问题</span>
          <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
        </div>
        <!-- <a
          @click="donwLoadPdf"
          :href="cjwtdownload2 ? cjwtdownload2 : '#'"
          target="_blank"
          >下载</a
        > -->
        <a @click="donwLoadPdf" target="_blank">下载</a>
      </div>
      <yd-accordion accordion>
        <yd-accordion-item
          v-for="(item, index) in list"
          :key="index"
          :title="item.question"
        >
          <div style="padding: 0.24rem" v-html="item.answer"></div>
        </yd-accordion-item>
      </yd-accordion>
      <div class="more" @click="problem()" v-show="problemShow">
        <button>更多</button>
      </div>
      <div class="more" @click="problems()" v-show="problemShows">
        <button>收起</button>
      </div>
      <!--加入我们-->
      <div
        class="join-us"
        style="height: 13.2rem; overflow: hidden"
        ref="scroll10"
      >
        <div class="content-top" ref="scroll7">
          <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
          加入我们
          <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
        </div>
        <div class="titleImg">
          <img :src="imagesAddressAddressZh+'/joinUs/joinus.jpg'" alt />
          <span
            >“让天下有更好用的加密货币”“用区块链技术解决金融霸权”，让世界更公平公正，解决一个国家对另外所有国家货币层面的掠夺是历史性大事业。现在国际支付有很多问题。比如今天你要从迪拜转10万美金去中国紧急采购，正常需要3个工作日，结果耽误了。这阻碍了社会生产效率的提高。如果人在国外，发生车祸，生命垂危，手术费因为国际转账要3天才能到账，错过抢救时间，生命因此可能凋零！生命是无法计量的价值！原子链将是国际金融转账速度慢，费用贵的区块链技术解决方案（国际转账目前需要3-5个工作日，用原子币将秒级到达地球任何一个角落）如果你觉得每天忙来忙去却感觉迷茫，你要问问自己，是否在虚度光阴，忘了当初的理想。如果你想干一番一辈子不后悔的历史性事业。加入IMFO及原子链吧，我们一起引导区块链行业正向发展！</span
          >
        </div>
        <div
          class="title-blue"
          id="ddd"
          style="margin-top: 0.4rem; margin-bottom: 0.2rem"
        >
          <div class="title-left"></div>
          <div class="title-font">我们需要这样的你</div>
        </div>
        <div class="navigation" id="listNav" style="margin-bottom: 0.4rem">
          <a
            href="javascript:void(0)"
            @click="menuClick(index, '#anchor-' + index)"
            v-for="(item, index) in menu"
            :key="index"
          >
            <div class="nav">{{ item }}</div>
          </a>
          <div style="clear: both"></div>
        </div>
        <div
          class="navigation"
          id="listNav2"
          style="margin-bottom: 0.4rem; display: none"
        >
          <a
            href="javascript:void(0)"
            @click="menuClick(index, '#anchor-' + index)"
            v-for="(item, index) in menu"
            :key="index"
          >
            <div class="nav">{{ item }}</div>
          </a>
          <div style="clear: both"></div>
        </div>
        <div class="title-blue">
          <div class="title-left"></div>
          <div class="title-font">我们这样回馈您</div>
        </div>
        <div class="listMe">
          <ul>
            <li v-for="(item, index) in listMe" :key="index">
              <img :src="imagesAddressAddressZh+'/jiaru-3.png'" alt />
              {{ item }}
            </li>
          </ul>
        </div>
        <div class="title-blue">
          <div class="title-font tblue">申请加入我们</div>
        </div>
        <div class="form listMe">
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="您的姓名">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="申请岗位">
              <el-select v-model="form.region" placeholder="请选择申请岗位">
                <el-option
                  v-for="(item, index) in form.cities"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系方式">
              <el-input v-model="form.phone"></el-input>
            </el-form-item>
            <el-form-item label="简  介">
              <el-input v-model="form.content"></el-input>
            </el-form-item>

            <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              multiple
              :limit="3"
              :on-exceed="handleExceed"
              :file-list="fileList"
            >
              <el-button size="small" type="default" style="background: #dbf4ff"
                >+上传简历</el-button
              >
            </el-upload>
            <!--请发送您的个人简历及附件到服务邮箱：hr@atoshi.org-->
            <el-button class="but" @click="Submission()">提交</el-button>
          </el-form>
        </div>
        <div class="six-title listMe" id="anchor-0">
          <div class="six-t-i">01</div>
          <div class="six-t-f">&ensp;&ensp;&ensp;一起改变世界的人</div>
        </div>
        <div class="listMe six-cont jj">
          <p>
            乔布斯："只有那些疯狂到以为自己能够改变世界的人，才能真正改变世界"
          </p>
          <p>如果你是那个疯狂的人，请务必跟我们联系，一起点亮世界！</p>
        </div>
        <div class="six-title listMe" id="anchor-1">
          <div class="six-t-i">02</div>
          <div class="six-t-f">&ensp;&ensp;&ensp;公链技术极客</div>
        </div>
        <div class="listMe six-cont jj">
          <p>
            你就是传说中的极客，code is the law and you are making the law!
            代码的世界，你是真正的王者。我们正需要王者归来，一起给世界赋能。
          </p>
        </div>
        <div class="six-title listMe" id="anchor-2">
          <div class="six-t-i">03</div>
          <div class="six-t-f">&ensp;&ensp;&ensp;原子链社区开发者</div>
        </div>
        <div class="listMe six-cont jj">
          <p>
            原子链开发者社区，是一支在区块链领域拥有一流技术和行业经验的团队，是一群有极高使命感的区块链
            “疯子”
          </p>
          <p>
            <img :src="imagesAddressAddressZh+'/jiaru-3.png'" alt />
            精通至少一种语言，如C / C ++ / Golang /
            python等，对区块链有浓厚的兴趣，并具有研究精神。
          </p>
          <p>
            <img :src="imagesAddressAddressZh+'/jiaru-3.png'" alt />
            熟悉数据结构和算法，并对密码学，安全协议和加密算法有深入研究。
          </p>
          <p>
            <img :src="imagesAddressAddressZh+'/jiaru-3.png'" alt />
            有过区块链项目经验者优先，例如Bitcoin、Hyperledge、Ethereum、EOS、NEO、Qtum等。
          </p>
        </div>
        <div class="six-title listMe" id="anchor-3">
          <div class="six-t-i">04</div>
          <div class="six-t-f">&ensp;&ensp;&ensp;股权合伙人招募</div>
        </div>
        <div class="listMe six-cont jj">
          <p>
            “身怀绝技”想要大展身手？
            <br />想要遇到你懂得也懂你的创业小伙伴？
            <br />不如打破壁垒，加入我们，获得股权，我们一直在等你........
            <a
              href="http://www.imfo.world/"
              style="color: blue; text-decoration: underline"
              >了解IMFO的使命</a
            >
          </p>
        </div>

        <div class="six-title listMe" id="anchor-5">
          <div class="six-t-i">05</div>
          <div class="six-t-f">&ensp;&ensp;&ensp;志愿者招募</div>
        </div>
        <div class="listMe six-cont jj">
          <p>
            用区块链解决金融霸权，助力实现大国梦！
            我们需要兼职和全职志愿者，不忘初心，一起奋斗，书写历史，成为志愿者条件：
          </p>
          <p>
            <img :src="imagesAddressAddressZh+'/jiaru-3.png'" alt />
            坚定信念，热爱，捍卫原子链的品牌和声誉。理解IMFO的使命。
          </p>
          <p>
            <img :src="imagesAddressAddressZh+'/jiaru-3.png'" alt />
            努力学习提升认识;
          </p>
          <p>
            <img :src="imagesAddressAddressZh+'/jiaru-3.png'" alt />
            有理想有抱负，愿意加入原子链一起改变世界
          </p>
          <p>
            <img :src="imagesAddressAddressZh+'/jiaru-3.png'" alt />
            积极向上愿意奋斗
          </p>
          <p>
            <img :src="imagesAddressAddressZh+'/jiaru-3.png'" alt />
            持有30万枚原子币以上
          </p>
        </div>
        <div class="six-title listMe" id="anchor-6">
          <div class="six-t-i">06</div>
          <div class="six-t-f">&ensp;&ensp;&ensp;其他人才</div>
        </div>
        <div class="listMe six-cont jj">
          <p>
            你很有才能，却找不到改变世界的支点？来原子链，说出你的梦想，大胆说出你想要的职位和待遇，我们将在第一时间回复；
          </p>
        </div>
        <div class="six-title listMe" id="anchor-7">
          <div class="six-t-i">07</div>
          <div class="six-t-f">&ensp;&ensp;&ensp;岗位直聘</div>
        </div>
        <div
          class="listMe six-cont jj"
          v-for="(item, index) of worker"
          :key="index"
        >
          <p>{{ item.postName }}</p>
          <p v-html="item.postDescribe"></p>
          <!--<p>区块链开发工程师</p>-->
          <!--<p>薪资待遇：50000-60000/月。</p>-->
          <!--<p>岗位职责：</p>-->
          <!--<p>1.负责基于区块链技术的核心代码开发;</p>-->
          <!--<p>2.持续跟进区块链技术在数字货币、智能合约、数字资产交易、支付等方向技术的研究;</p>-->
          <!--<p>3.积极探索区块链技术在金融等方向新的落地场景，为公司业务发展提供持续支撑;</p>-->
          <!--<p>任职要求:</p>-->
          <!--<p>1. 本科以上学历,计算机及相关专业；</p>-->
          <!--<p>2. 掌握Bitcoin，Ethereum，HyperLedger、EOS等主流区块链技术相关机制原理与去中心化思想；</p>-->
          <!--<p>3. 熟练掌握Go，Java，C++等主流区块链系统开发语言至少一种，Go优先，参与过区块链开发社区</p>-->
          <!--<p>并贡献源码者优先；</p>-->
          <!--<p>4. 熟练掌握加密算法、共识算法、控制论、博弈论、网络安全、分布式计算。</p>-->
          <!--<p>5. 了解主流NoSQL数据库的原理使用，尤其是KV型数据库，包括不限于LevelDB，RocksDB等；</p>-->
          <!--<p>6. 熟悉Linux操作系统，熟练掌握Docker容器技术的原理，部署和使用优化；</p>-->
        </div>
        <div class="listMe sp">
          <!-- <button class="but" @click="tiClick()">提交申请</button> -->
          <p>更多请联系人力资源：hr@atoshi.org</p>
        </div>
      </div>
      <div class="more" @click="joinClick()" v-show="joinshow">
        <button>更多</button>
      </div>
      <div class="more" @click="joinClick()" v-show="!joinshow">
        <button>收起</button>
      </div>
      <div style="clear: both"></div>

      <!-- <div class="more mores">
              <button>更多</button>
      </div>-->
      <!--<div class="content-top" style="margin-top:-.2rem;">-->
      <!--<img src="../assets_ch/shouye-xiantiao.png" alt>-->
      <!--天使投资-->
      <div class="content-top" ref="scroll10">
        <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
        天使投资
        <img :src="imagesAddressAddressZh+'/shouye-xiantiao.png'" alt />
      </div>
      <div class="titleImg">
        <img :src="imagesAddressAddressZh+'/angel2.png'" alt />
        <p>
          开曼原子基金有限公司是原子币的发行方和资本管理方并设有原子链天使投资基金
        </p>
        <br />
        <p>
          原子链项目的收入，除去研发和运营费用，剩余资本的盈余用来投资各种加密货币、高潜力股票和房产、做天使投资。
          我们寻找具有以下特点的公司进行天使投资：
        </p>
        <br />
        <p>
          <img :src="imagesAddressAddressZh+'/circle.png'" alt style="width: 2%" />
          公司业务最好面对C端客户。
        </p>
        <p>
          <img :src="imagesAddressAddressZh+'/circle.png'" alt style="width: 2%" />
          能有使用原子币进行打折支付的场景并且在投资后必须接受原子币进行打折支付
        </p>
        <p>
          <img :src="imagesAddressAddressZh+'/circle.png'" alt style="width: 2%" />
          公司具有巨大的增长空间
        </p>
        <p style="color: #666">
          如果你的公司具有以上特点，请联系我们：
          <!--18518888388（微信同号）-->
          微博搜索：廖望么么哒，私信注明：寻找天使投资
          并将项目BP发到：liao@atoshi.org
        </p>
      </div>

      <div class="blue-div2" ref="scroll8">
        <div class="foot_link">
          <div class="shang">
            <p class="p11">原子链官方:</p>
            <!--<a id="bdpho">-->
            <!--<p class="p22" @click="gobd('18516888388')" >客服：<span class="gllink">18516888388(微信同号）</span></p>-->
            <!--</a>-->
            <div class="weixins">
              <div class="wx_item">
                <img
                  :src="imagesAddressAddressZh+'/weixin1.png'"
                  id="weixin1"
                  @click="clickShowBigImage('imageWx01')"
                  class="wx_img"
                />
                <br />(微信客服1)
              </div>
              <!-- <div class="wx_item" style="margin-left: 0.7rem">
                <img
                  :src="imagesAddressAddressZh+'/weixin1.png'"
                  id="weixin2"
                  @click="clickShowBigImage('imageWx02')"
                  class="wx_img"
                />
                <br />(微信客服2)
              </div> -->
            </div>
          </div>
          <div class="zhong" style="margin-top:0.45rem;">
            <p class="p11">技术客服:<br />(仅限技术问题)</p>
            <!--<a id="bdpho">-->
            <!--<p class="p22" @click="gobd('18516888388')" >客服：<span class="gllink">18516888388(微信同号）</span></p>-->
            <!--</a>-->
            <div class="lianjies">
                <a><img
                  :src="imagesAddressAddressZh+'/weixin1.png'"
                  id="weixin1"
                  @click="clickShowBigImage('tech01')"
                  class="wx_img"
                /></a>
                <a><img
                  :src="imagesAddressAddressZh+'/feixin22.png'"
                  id="weixin1"
                  @click="clickShowBigImage('tech02')"
                  class="wx_img"
                /></a>
                <a><img
                  src="../assets/img/whatApp.png"
                  id="weixin1"
                  @click="clickShowBigImage('tech03')"
                  class="wx_img"
                /></a>
            </div>
          </div>
          <div class="zhong" style="margin-top: 0.45rem">
            <p class="p11">官方链接:</p>
            <div class="lianjies">
              <a @click="downloadApp('https://weibo.com/u/7404867544')">
                <img :src="imagesAddressAddressZh+'/weibo22.png'" />
              </a>
              <a @click="downloadApp('https://www.youtube.com/channel/UCnerJ-uKVBfHR82kpYXJxMQ/videos')">
                <img :src="imagesAddressAddressZh+'/youtube.png'" />
              </a>
              <a @click="downloadApp('https://www.linkedin.com/company/atoshiofficial')">
                <img :src="imagesAddressAddressZh+'/linkin.png'" />
              </a>
              <a @click="downloadApp('https://t.me/atoshiofficial')">
                <img :src="imagesAddressAddressZh+'/feixin22.png'" />
              </a>
              <a @click="downloadApp('https://t.me/atoshichannel')">
                <img src="../assets/img/telegram_icon.png" />
              </a>
              <a @click="downloadApp('https://chat.whatsapp.com/LQJd526uiT4AsbdIMNYQc9')">
                <img src="../assets/img/whatApp.png" />
              </a>
              <a @click="downloadApp('https://scan.atoverse.info')">
                <img :src="imagesAddressAddressZh+'/atossearch.png'" />
              </a>
            </div>
            <div class="lianjies">
              <a @click="downloadApp('https://leshua.info')">
                <img src="../assets/img/detok.png" />
              </a>
              <a @click="downloadApp('https://twitter.com/atoshiofficial')">
                <img :src="imagesAddressAddressZh+'/xiaoniao22.png'" />
              </a>
              <a @click="downloadApp('https://haowuju.cn/#/index')">
                <img src="../assets/hwjLogo.png" />
              </a>
              <a
                @click="downloadApp('https://www.facebook.com/atoshifoundation/')"
              >
                <img :src="imagesAddressAddressZh+'/facebook22.png'" />
              </a>
              <a @click="downloadApp('https://m.imfo.world')">
                <img :src="imagesAddressAddressZh+'/imfo.png'" />
              </a>
              <a @click="jump">
                <img :src="imagesAddressAddressZh+'/info.png'" />
              </a>
              <a @click="downloadApp('https://www.atoshi.info/charity/#/')">
                <img src="../assets/charity.png" />
              </a>
            </div>
          </div>
          <div class="xia" style="margin-top: 0.45rem">
            <p class="p11">CEO廖望:</p>
            <div class="lianjies">
              <a
                @click="downloadApp('https://weibo.com/liaodoer')"
                style="margin-left: 0"
              >
                <img :src="imagesAddressAddressZh+'/weibo22.png'" />
              </a>
              <a
                @click="downloadApp('https://user.qzone.qq.com/75510696/infocenter')"
              >
                <img :src="imagesAddressAddressZh+'/kongjian22.png'" />
              </a>
              <a @click="downloadApp('https://www.facebook.com/leomarsliao/')">
                <img :src="imagesAddressAddressZh+'/facebook22.png'" />
              </a>
              <a @click="downloadApp('https://www.linkedin.com/in/leomars/')">
                <img :src="imagesAddressAddressZh+'/linkin.png'" />
              </a>
              <a @click="downloadApp('https://twitter.com/liaodoer')">
                <img :src="imagesAddressAddressZh+'/xiaoniao22.png'" />
              </a>
            </div>
            <div class="lianjies">
              <a @click="downloadApp('http://xima.tv/fujCjB')">
                <img :src="imagesAddressAddressZh+'/ximalaya22.png'" />
              </a>
              <a class="bigdouyin">
                <img :src="imagesAddressAddressZh+'/douyin.png'" class="bigdouyin1" @click="clickShowBigImage('imageDouyin')"/>
              </a>
              <a class="bigleshua">
                <img src="../assets/img/detok.png" class="bigleshua1" @click="clickShowBigImage('imageLeshua')"/>
              </a>
            </div>
          </div>
          <div class="shengming_box">
            <span class="span1">重要声明:</span>
            <br />
            <span class="span2"
              >在公链研发出来以前，原子链APP里原子币是一种基于区块链的通用积分。目前现阶段并未全面开展公链研发，属于积分记账功能。</span
            >
            <br />
            <span class="span2"
              >以上内容版权归开曼原子基金有限公司所有。所有关于IMFO,原子链,原子币的技术理念，特点和规划都只是我们的愿景，要实现是个长期艰苦努力的过程，并且将来可能根据研发和实际市场情况进行调整。原子链项目有风险，也可能失败，任何人说原子链或原子币保赚不赔，请不要相信并请向我们举报。原子链官方保留更改其中内容和解释的最终权。原子链，原子恋，IMFO，原子币，ATOSHI
              的相关名字我们已经全球注册商标专利，侵权必究。</span
            >
          </div>
          <div class="banquan_foot">
            ©Copyright | 原子链 and ATOSHI All Rights Reserved | <br />Powered
            by 开曼原子基金有限公司
          </div>
        </div>
      </div>
    </div>
    <div v-if="videoFlag">
      <viewVideo
        @click="gotoHome($event)"
        :videoUrl="videoUrls"
        :videotitle="videoTitle"
        :videolist="videoList"
        :imgurl="imgurl"
      ></viewVideo>
    </div>
    <div
      v-if="audioFlag"
      style="
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.2);
        width: 100%;
        height: 100%;
      "
    >
      <audio
        :src="src"
        controls="controls"
        loop="loop"
        autoplay="autoplay"
        style="margin-top: 1rem"
      ></audio>
    </div>
    <div
      class="webdown_box"
      v-if="isshowzhezhao"
      @click="isshowzhezhao = false"
    >
      <img :src="imagesAddressAddressZh+'/img/webdown.png'" />
    </div>
    <!-- vant 遮罩 -->
    <van-overlay :show="showVantOverlay" @click="showVantOverlay = false">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" />
      </div>
    </van-overlay>
    <van-popup class="whatAppCode_img" style="text-align: center;font-weight: 500;border-radius: 5px" v-model="showBigImage">
      <img v-if="imageType=='imageWx01'" :src="imagesAddressAddressZh+'/kefunum1.png'" />
      <img v-if="imageType=='imageWx02'" :src="imagesAddressAddressZh+'/kefunum2.png'" />
      <img v-if="imageType=='imageDouyin'" :src="imagesAddressAddressZh+'/bigdouyin.png'" />
      <img v-if="imageType=='imageLeshua'" :src="imagesAddressAddressZh+'/bigleshua.png'" />
      <img v-if="imageType=='tech01'" src="../assets/img/tech01.png" />
      <img v-if="imageType=='tech02'" src="../assets/img/tech02.png" />
      <img v-if="imageType=='tech03'" src="../assets/img/tech03.png" />
    </van-popup>

    <!-- 关键数据 -->
    <van-popup style="text-align: center;font-weight: 500;border-radius: 5px" v-model="showkeyNumber">
        <div style="display: flex;flex-direction: column;align-items: center;width: 89vw;border-radius: 3.2vw;position: relative;padding: 8vw 0;box-sizing: border-box;" @click.stop>
            <img src="../assets/img/close.png" alt="" srcset="" style="width: 6.4vw;height: 6.4vw;position: absolute;right: 3vw;top: 4vw;" @click="showkeyNumber = false">
            <div style="position: relative;">
                <span style="z-index: 2;font-size: 5.3vw;font-weight: bold;color: #5C90FB;">原子币总量</span>
                <div style="width: 28.8vw;height: 2.6vw;background: rgba(93, 189, 245, .2);position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);z-index: 1;"></div>
            </div>
            <div style="position: relative;margin-top: 8vw">
                <img src="../assets/img/path.png" alt="" srcset="" style="width: 37.8vw;">
                <ul style="width: 100%;position: absolute;top: 4vw;left: -14vw;">
                    <li style="display: flex;flex-direction: column;align-items: flex-end;">
                        <!-- <img src="../assets/img/dot.png" alt="" srcset="" style="width: 5.3vw;height: 5.3vw;"> -->
                        <p style="color: #333;margin-top: 2vw;">
                            <span style="font-size: 3.7vw;font-weight: bold;">1000亿枚</span>
                            <span style="font-size: 3.2vw;">(2018年3月)</span>
                        </p>
                        <div style="display: flex;align-items: center;justify-content: center;width: 42.6vw;height: 8vw;border: .5vw dashed #aaa;border-radius: 1.3vw;color: #888888;font-size: 2.6vw;">原子币初始发行量（Erc20）</div>
                    </li>
                    <li style="width: 50vw;margin: 5vw 0 0 16vw;background: #E2F4FF;color: #529CFB;border-radius: 1.2vw;padding: .5vw 2vw;box-sizing: border-box;">
                        <span style="font-size: 3.2vw;font-weight: bold;">同比例扩大100倍</span>
                        <span style="font-size: 2.6vw;">(2022年3月)</span>
                    </li>
                    <li style="display: flex;align-items: center;margin: 4vw 0 0 15vw;">
                        <!-- <img src="../assets/img/dot.png" alt="" srcset="" style="width: 5.3vw;height: 5.3vw;"> -->
                        <div style="margin-left: 8vw;text-align: left;">
                            <p style="color: #333">
                                <span style="font-size: 3.7vw;font-weight: bold;">10万亿枚</span>
                                <span style="font-size: 3.2vw;">(现在)</span>
                            </p>
                            <div style="display: flex;align-items: center;width: 42.6vw;height: 8vw;border: .5vw dashed #aaa;border-radius: 1.3vw;color: #888888;font-size: 2.6vw;padding-left: 2vw;box-sizing: border-box;margin-top: 1vw;">原子链国际版App上线后</div>
                        </div>
                    </li>
                    <li style="width: 50vw;margin: 6vw 0 0 16vw;background: #E2F4FF;color: #529CFB;border-radius: 1.2vw;padding: .5vw 2vw;box-sizing: border-box;">
                        <span style="font-size: 3.2vw;font-weight: bold;">再次同比例扩大100倍</span>
                        <span style="font-size: 2.6vw;">(将来)</span>
                    </li>
                    <li style="display: flex;align-items: center;margin: 6vw 0 0 1vw;">
                        <div style="margin-right: 8vw;text-align: right;">
                            <p style="color: #333">
                                <span style="font-size: 3.7vw;font-weight: bold;">1000 万亿枚</span>
                                <span style="font-size: 3.2vw;">(上主网后)</span>
                            </p>
                            <div style="display: flex;align-items: center;justify-content: flex-end;width: 42.6vw;height: 8vw;border: .5vw dashed #aaa;border-radius: 1.3vw;color: #888888;font-size: 2.6vw;padding-right: 2vw;box-sizing: border-box;margin-top: 1vw;">主网上线后，原子币的最终总量</div>
                        </div>
                        <!-- <img src="../assets/img/dot.png" alt="" srcset="" style="width: 5.3vw;height: 5.3vw;"> -->
                    </li>
                </ul>
            </div>
            <p style="width: 80vw;color: #333333;font-size: 3.7vw;margin-top: 8vw;">说明：1ATOS(Erc20)=100ATOS(原子链国际版App)=10000ATOS（上主网后）</p>
            <ul style="color: #38AAFF;font-size: 3.2vw;margin-top: 2.6vw;">
                <li @click="downloadApp('https://etherscan.io/token/0x4d0528598f916fd1d8dc80e5f54a8feedcfd4b18')" style="display: flex;align-items: center;justify-content: center;">
                    <span>在 ETH 区块链浏览器中查看</span>
                    <img src="../assets/img/arr.png" alt="" srcset="" style="width: 4.5vw;height: 4.5vw;margin-left: 1vw;">
                </li>
                <li @click="judgeIp" style="display: flex;align-items: center;justify-content: center;margin-top: 2vw;">
                    <span>下载原子链国际版App体验</span>
                    <img src="../assets/img/arr.png" alt="" srcset="" style="width: 4.5vw;height: 4.5vw;margin-left: 1vw;">
                </li>
                <li @click="downloadApp('https://scan.atoshi.org/')" style="display: flex;align-items: center;justify-content: center;margin-top: 2vw;">
                    <span>在 Atoshi 测试网中查看</span>
                    <img src="../assets/img/arr.png" alt="" srcset="" style="width: 4.5vw;height: 4.5vw;margin-left: 1vw;">
                </li>
            </ul>
        </div>
    </van-popup>

  </yd-layout>
</template>

<script>
import swiper from "swiper";
import Swiper from "@/components/swiper.vue";
import Slide from "@/components/slide.vue";
import viewVideo from "@/components/viewVideo.vue";
import { enumsZh } from "../enum";
import { enumsImages } from "../enum";
import { Image as VanImage } from "vant";

import {
  api_video,
  api_addApplicant,
  api_findPrice,
  api_listTeamMembers,
  api_listCommonProblem,
  api_listAudio,
  api_listCultureFolder,
  api_listNews,
} from "../components/APIKeys";
import { Toast, Overlay, Loading } from "vant";
import BigNumber from 'bignumber.js'
import server from '../server/index.js'

export default {
  name: "AtomicChain-home",
  components: {
    Swiper,
    Slide,
    viewVideo,
  },
  props: [],
  data: function () {
    let self = this;
    return {
      showkeyNumber: false,
      newAdd: false,
      showBigImage:false,
      imageType:"",
      imagesAddressCommon:enumsImages.addressCommon,
      imagesAddressAddressZh:enumsImages.addressZh,
      showVantOverlay: false, //遮罩
      otheryingyongtexts: [
        {
          text: "乐唰(Detok)将使用区块链技术保护用户的视频版权，使视频成为数字资产并且可以用来交易",
          text2:
            "乐唰(Detok)将使用区块链技术保护用户的视频版权，使视频成为数字资产并且可以用来交易。原子链用户在乐唰(Detok) APP上可以看视频赚钱，也可以上传视频赚钱，赚来的钱可以提现也可以兑换成原子币，持有原子币者可以变成视频审核官，分享所审核视频的收入，这样我们运营成本变低，有一定的竞争优势。",
          iszhankai: false,
        },
        {
          text: "许愿，爱情鉴证，婚姻鉴证。本鉴证同步到区块链网络上，就算天荒地老，海枯石烂，",
          text2:
            "许愿，爱情鉴证，婚姻鉴证。本鉴证同步到区块链网络上，就算天荒地老，海枯石烂，您的许愿或者鉴证将永远不会磨灭。",
          iszhankai: false,
        },
        {
          text: "我们有各种各样的游戏供我们的用户休闲娱乐，包括成语、象棋等益智和学习类游戏。",
          text2:
            "我们有各种各样的游戏供我们的用户休闲娱乐，包括成语、象棋等益智和学习类游戏。用户玩游戏可以获得原子币。目前我们有1000多万注册用户，如果每天有1%的人能贡献10块钱，收入就能达到100多万一天，将来这个收入会更高。",
          iszhankai: false,
        },
        {
          text: "我们跟携程同程艺龙等平台合作，用户可以在我们的平台上以优惠的价格定酒店，机票",
          text2:
            "我们跟携程同程艺龙等平台合作，用户可以在我们的平台上以优惠的价格定酒店，机票，火车票，船票等。我们将送币给用户。目前我们有1000多万注册用户，如果有1%的人订酒店，每间酒店我们的平均佣金10块钱，就是100多万一天。",

          iszhankai: false,
        },
        {
          text: "我们已研发出原子链国际版（ATOSHI Global），增加国外粉丝的数量。",
          text2:
            "我们已研发出原子链国际版（ATOSHI Global），增加国外粉丝的数量。中国有500多万的商家在亚马逊，阿里巴巴等平台上做跨境电商，我们背靠这么丰厚的卖家资源更容易做大，做好，帮500万商户将产品卖到全世界去，把给世界赋能这句话落到实处。",
          iszhankai: false,
        },
        {
          text: "原子链用户在原子链视频上也可以看视频赚钱，也可以上传视频赚钱，赚来的钱可以提现",
          text2:
            "原子链用户在原子链视频上也可以看视频赚钱，也可以上传视频赚钱，赚来的钱可以提现也可以兑换成原子币，持有原子币者可以变成视频审核官，分享所审核 视频的收入，这样我们运营成本变低，有一定的竞争优势。",
          iszhankai: false,
        },
        {
          text: "聊天软件可以支持创建10万人的聊天群，可以打语音电话，发视频，发图片，分享朋友圈",
          text2:
            "聊天软件可以支持创建10万人的聊天群，可以打语音电话，发视频，发图片，分享朋友圈（朋友圈可以对所有人开放，或者只对朋友开放；评论可以对所有人开放或者只对朋友开放; 朋友圈可以兼具微博的功能）。",
          iszhankai: false,
        },
        {
          text: "彩铃，腾讯视频会员，优酷视频会员，水电缴费，电话费充值也将陆续落地。",
          text2:
            "彩铃，腾讯视频会员，优酷视频会员，水电缴费，电话费充值也将陆续落地。",
          iszhankai: false,
        },
        {
          text: "原子链区块浏览器是一个搜索工具，是原子链上数据可视化的主要窗口",
          text2:
            "原子链区块浏览器是一个搜索工具，是原子链上数据可视化的主要窗口，允许所有原子链用户查看原子区块链的历史。原子链区块浏览器除了可以记录和统计原子链网络的每个区块、每笔交易以及地址信息外，还可以观察记录原子链各节点的运行数据。原子链公链目前仍在测试阶段。",
          iszhankai: false,
        },
        {
          text: "是一款安全、便捷的数字资产管理工具，为您提供全面的数字资产管理解决方案。原子链钱包采用最先进的加密技术",
          text2: "是一款安全、便捷的数字资产管理工具，为您提供全面的数字资产管理解决方案。原子链钱包采用最先进的加密技术，确保您的资产安全。您可以创建自己的钱包，并获 得一个唯一的私钥，用于保护您的资产免受黑客和未经授权的访问。原子链钱包APP 提供了简洁直观的用户界面，方便您进行资产的接收、发送和存储。",
          iszhankai: false,
        },
        {
          text: "是一款为了满足用户对数字藏品的收藏、欣赏与分享需求的“新一代数字藏品App”，致 力于传统和现代文化艺术的推广。",
          text2: "是一款为了满足用户对数字藏品的收藏、欣赏与分享需求的“新一代数字藏品App”，致 力于传统和现代文化艺术的推广。原宇宙数字藏品是一种限量发行的数字文创作品， 包括但不限于画作、图片、音乐，视频，3D模型等各种形式，每一份数字藏品拥有链 上独一无二的所有权凭证，不可篡改、不可拆分、不可复制。",
          iszhankai: false,
        },
        {
          text: "是全球首款区块链概念的密码管理软件，原子密码箱是安全易用的专业密码管理器。使用原子密码箱",
          text2: "是全球首款区块链概念的密码管理软件，原子密码箱是安全易用的专业密码管理器。使用原子密码箱，您只需要记住一个密码。智能安全的数据存储，支持多平台，一键即可安全登录网站、填写表单。您的所有其他密码和重要信息都被帐户密码保护，帐户密码只有您知道。",
          iszhankai: false,
        },
        {
          text: "是一款帮助用户规律生活的小程序。早晨，用户可以打卡记录自己起床的时间，激发自己早起的动力，",
          text2: "是一款帮助用户规律生活的小程序。早晨，用户可以打卡记录自己起床的时间，激发自己早起的动力，养成好习惯； 晚上，用户可以打卡记录自己睡觉的时间，监控自己的睡眠质量，调整作息，保持身体健康。 同时，早晚安打卡还支持社交分享，用户可以将自己的打卡结果分享给好友，让大家一起监督，共同提高生活质量。 小原子早晚安以简约、清新的风格为主，界面简洁易懂，操作方便快捷，是一款值得尝试的小程序。",
          iszhankai: false,
        },
        {
          text: "是一款基于人工智能技术开发的语言处理工具。其最大的特点是采用了高级语言模型GPT技术，",
          text2: "是一款基于人工智能技术开发的语言处理工具。其最大的特点是采用了高级语言模型GPT技术，能够精准的预测下一个词或句子，促使文章更加流畅的生成，准确的表达出来。该产品可广泛用于智能客服、问答系统、机器翻译等多个领域。原子链AI可以根据用户的需求进行灵活定制和优化。此外，原子链AI还支持多种语言的处理和分析，包括英语、中文、德语、法语等。如果您需要一个快速、准确的智能语言处理工具，原子链AI无疑是您的最佳选择。",
          iszhankai: false,
        },
      ],
      yuanqiguihuatexts: [
        {
          text: "加密软件，图片处理，视频编辑等小软件支付将比法币支付享受最高可达50%的优惠。",
          text2:
            "加密软件，图片处理，视频编辑等小软件支付将比法币支付享受最高可达50%的优惠。",
          iszhankai: false,
        },
        {
          text: "游戏软件中购买金币将比以太坊和法币更便宜，并且玩家也将获得原子币作为奖励。",
          text2:
            "游戏软件中购买金币将比以太坊和法币更便宜，并且玩家也将获得原子币作为奖励。",
          iszhankai: false,
        },
        {
          text: "分布式文件存储将用原子币进行支付。",
          text2: "分布式文件存储将用原子币进行支付。",
          iszhankai: false,
        },
        {
          text: "原子链计划采用POD算法，每个用户都贡献自己所需算力的2倍算力来获得免费转账服务，",
          text2:
            "原子链计划采用POD算法，每个用户都贡献自己所需算力的2倍算力来获得免费转账服务，形成一个巨大的算力池。用户越多，算力越快。理论上讲，原子链可以运行无限量Dapp，各个行业以后都可以在我们的链上进行开发和应用，构建一个涵盖社会生活各个方面的综合立体生态，各个生态都可以享受优惠折扣。",
          iszhankai: false,
        },
        {
          text: "原子链将打造成区块链中的分布式操作系统，也就是说可以在原子链的上开发各种Dapp",
          text2:
            "原子链将打造成区块链中的分布式操作系统，也就是说可以在原子链的上开发各种Dapp， 而且用户界面非常友好简单，就跟你操作系统点击鼠标一样简单。这样的话，各个行业都可以在我们的原子链上开发自己的链，跟原子链是并行链，没有谁是主链谁是支链，大家平等。各条链之间又可以跨链用原子币ATOS进行价值支付。",
          iszhankai: false,
        },
        {
          text: "在原子链上面发行智能合约，不需要懂代码，你只需要点击菜单，小白也可以发代币也可",
          text2:
            "在原子链上面发行智能合约，不需要懂代码，你只需要点击菜单，小白也可以发代币也可以运行智能合约。这种代币的运行和智能合约将用原子币支付。",
          iszhankai: false,
        },
      ],
      kefu1: false,
      kefu2: false,
      // acturl: "https://m.atoshi.org/#/AtomicChain/home?VNK=4e5e4a26&lang=zh_CN",
      // acturl: "https://chplus.atoshi.org/#/",
      acturl:"zh",
      value1: "中文",
      imgFont: [
        enumsImages.addressZh+"/lunbo_p5.png",
        // require("../assets_ch/p2.png"),
        enumsImages.addressZh+"/p3.png",
        enumsImages.addressZh+"/p4.png",
        // enumsImages.addressZh+"/p_6.png",
        enumsImages.addressZh+"/p_7.png",
      ],
      img1: enumsImages.addressZh+"/p11.png",
      img2: enumsImages.addressZh+"/p22.png",
      img3: enumsImages.addressZh+"/p33.png",
      img4: enumsImages.addressZh+"/p44.png",
      img5: enumsImages.addressZh+"/p555.png",
      img6: enumsImages.addressZh+"/p66.png",

      imgleft: enumsImages.addressZh+"/p11.png",
      imgright: enumsImages.addressZh+"/p22.png",
      index1: 0,
      index: 0,
      time: null,
      timer: null,
      findPrice: 0,
      userNums: 0,
      teamShow: false,
      joinShow: false,
      folderShow: false,
      videoShow: false,
      audioFlag: false,
      src: "",
      worker: "",
      problemShow: true,
      problemShows: false,
      audioShow: true,
      audioShows: false,
      newShow: true,
      newShows: false,
      sixS: true,
      sixSs: false,
      sixShow: false,
      videoFlag: false,
      videoUrls: "",
      videoTitle: "",
      imgurl: "",
      odd: [
        {
          img: enumsImages.addressZh+"/six/icon-lingzhuanzhang.png",
          title: "低转账费用",
        },
        {
          img: enumsImages.addressZh+"/six/icon-miaojizhifu.png",
          title: "秒级支付",
        },
        { img: enumsImages.addressZh+"/six/icon-shiming.png", title: "监管安全" },
        { img: enumsImages.addressZh+"/six/icon-zhiwen.png", title: "安全交易" },
        { img: enumsImages.addressZh+"/six/icon-zhongxin.png", title: "操作系统" },
        { img: enumsImages.addressZh+"/six/icon-xiaobai.png", title: "智能合约" },
        { img: enumsImages.addressZh+"/six/t8.png", title: "越用越稀有" },
        { img: enumsImages.addressZh+"/six/t7.png", title: "映射机制" },
        { img: enumsImages.addressZh+"/six/t9.png", title: "回购机制" },
      ],
      odds: [
        {
          content:
            "用户需要贡献闲置原力，获取低转账服务，形成巨大原力池。在原子链发行智能合约，需要抵押一定数量的原子币，合约越多，币越少",
        },
        {
          content:
            "用户要转一笔账，需要贡献闲置原力，帮全网处理两笔交易，从而形成一个巨大的原力池，将可以瞬间处理亿万级别交易",
        },
        {
          content:
            "早期互联网是匿名的，为了防止网络犯罪，现在已经是实名制的天下了。区块链也是一样，安全需求是人类基本需求。",
        },
        {
          content:
            "以后大家不用担心丢失钱包密码和助记词私钥，通过验证身份，指纹，刷脸多环验证，丢了密码丢了手机也可以高枕无忧找回来。",
        },
        {
          content:
            "在原子链的上可以开发各种Dapp，各个行业都可以在原子链上开发自己的链，跟原子链是并行链。原子币ATOS基本应用场景会非常广阔，成为世界硬通货",
        },
        {
          content:
            "我们会将智能合约模块化，以菜单形式呈现给用户，你只需要点击菜单，输入参数，不用懂代码，也不需要代码审计，就可以运行智能合约",
        },
        {
          content:
            "用户越多，冻结的币越多，每个用户要激活钱包需要冻结2000个币，用户越多，数量越少。",
        },
        {
          content:
            "已经同比例放大100倍，主网上线前再放大100倍，总共1万倍。放大只针对Atoshi App里面的币放大，已经转成以太坊ERC20的原子币数量暂时保持不变，到主网上线稳定，更加去中心化后直接映射放大1万倍。",
        },

        {
          content: "数量有限，不可增发，原子链项目的部分利润将用于回购原子币",
        },
      ],
      news: [],
      newP: [],
      video: [],
      videos: [],
      enterprise: [],
      enterprises: [],
      audio: [],
      audios: [],
      money: {
        img: enumsImages.addressZh+"/jinianbi.jpg",
        content:
          "原子链（ATOSHI）是一种基于区块链去中心化的金融解决方案。其目标是通过区块链与分布式账本技术，构建一个全球范围内的货币自由流通体系。这个体系可以让每个用户自由的进行国际间金融交易。原子链采用五层架构：数据层、网络层、共识层、合约层、应用层。数据层使用分布式账本技术，实现货币的发行、支付、交换等操作；网络层采用P2P网络协议实现的对等网络；共识层基于POD及BFT共识算法；合约层采用创世合约和多语言智能合约进行货币的发行与管理，对虚拟机进行了优化，支持图灵完备，采用自省机制防止图灵完备中的死锁状态；应用层对多种类型的终端友好，方便开发者便捷的基于原子链开发应用。通过去中心化的自治形式，建造一个多元化的金融流通网络，提升货币的流动性、安全性、广泛性。ATOS作为共赢生态中一种货币单位，目标是成为全球国际间交易的通用性货币。原子链作为一个开放性系统，用户可以基于原子链API开发各种独立的DAPP，建立个性化的应用场景。",
      },
      team: [],
      teams: [],
      list: [],
      lists: [],
      menu: [
        "一起改变世界的人",
        "公链技术极客",
        "社区开发者",
        "企业合伙人",
        "原子链大使",
        "志愿者",
        "其他",
        "岗位直聘",
      ],
      listMe: [
        "加入有使命感的社群，一起改变世界，创造历史，实现生命的价值",
        "按贡献程度享受项目奖励的分红。",
        "优秀有贡献人才将成为原子基金会股东，享受分红。",
        "社区氛围很好，很有激情和使命",
      ],
      form: {
        name: "",
        cities: [
          "公链技术极客",
          "社区开发者",
          "企业合伙人",
          "原子链大使",
          "志愿者",
          "其他",
          "岗位直聘",
        ],
        region: "",
        phone: "",
        content: "",
      },
      fileList: [],
      bt1: true,
      bt2: false,
      td1: true,
      td2: false,
      joinshow: true,
      bpsdownload: "",
      bpsdownload2: "",
      cjwtdownload: "",
      cjwtdownload2: "",
      // hrefurl: "https://chplus.1atoshi.top/#",
      // hrefurl:'http://10.100.103.204:8181/#',
      leshuaAddress: "https://img.leshuapro.com/apk/leshua.apk",
      idiomAddress: "https://game-img.atoshi.mobi/chengyuapk/ttcy.apk",
      isshowzhezhao: false,
      videoList: [],
      downloadUrl: enumsZh.downloadUrl,
      bannerVideo: {
        readVideoUrl: enumsZh.atoscnMp4,
        videoUrl480: enumsZh.atoscnMp4480,
        videoUrl720: enumsZh.atoscnMp4720,
        videoUrl1080: enumsZh.atoscnMp41080,
        videoImg: "https://yuanzilian-image.oss-cn-hangzhou.aliyuncs.com/cn_image/f2423c41-d4bf-48c3-929d-7cbe9009b406.jpg",
        videoTitle: "什么是原子币？",
        youtubeId: "0grh8gFvFeg",
      },
      ceoVideo:{
        readVideoUrl: enumsZh.ceoAtoscnMp4,
        videoUrl480: enumsZh.ceoAtoscnMp4480,
        videoUrl720: enumsZh.ceoAtoscnMp4720,
        videoUrl1080: enumsZh.ceoAtoscnMp41080,
        videoImg: "https://image.juhaowu.cn/cn_video/video/TWATOSHICOVER.jpg",
        videoTitle: "",
        youtubeId: "OZc0_dSJQCI",
      },
      languageType:'zh',
      todayUrl:"",
      downloadBtn:false,
    };
  },
  computed: {
    // userInfo: ({user}) => user.userInfo,
    textSplice() {
      if (!this.bt2) {
        if (this.money.content.length > 84) {
          return this.money.content.substr(0, 89) + "…";
        }
      } else {
        return this.money.content.substr(0, 89);
      }
    },
    tdteamOne() {
      if (!this.td2) {
        if (this.team[0].memberIntroduction.length > 134) {
          return this.team[0].memberIntroduction.substr(0, 134) + "…";
        }
      } else {
        return this.team[0].memberIntroduction.substr(0);
      }
    },
  },
  filters: {
    title(msg) {
      if (msg.length >= 6) {
        msg = msg.substr(0, 6) + "…";
      }
      return msg;
    },
    content(msg) {
      if (msg.length > 12) {
        msg = msg.substr(0, 12) + "…";
      }
      return msg;
    },
  },
  created()
  {

    // var sUserAgent = navigator.userAgent.toLowerCase();
    // var isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
    // if(!isMobile)
    // {
    //   window.location.href = "https://pc-chplus.1atoshi.top";
    // }
  },
  mounted() {
    this.languageType = "zh";
    document.title = "原子链-原子恋-原子币-ATOS,给世界赋能";
    let self = this;
    $(".tops").css({
      height: document.body.clientHeight - 10,
      "margin-left": document.body.clientWidth,
    });
    $(".sizeImg").eq(3).css({ width: "4rem", height: "1.2rem" });
    $(".sizeImg").eq(-1).css({ width: "7rem", height: "1.2rem" });
    let carousel = $(".six-odd-Carousel .odds");
    carousel.eq(0).css({ visibility: "visible" });
    let navigation = $(".navigation .nav");
    navigation.eq(0).css({ background: "#3E9BE8", color: "#fff" });
    setTimeout(function () {
      self.jquery();
    }, 2000);
    this.auto();
    //接口查询
    this.onLoad();
    this.getWorker();
    this.getTodayUrl();
    //
  },
  methods: {
    controlKNumber() {
        this.showkeyNumber = true;
    },
    // 获取当日访问官网地址
    getTodayUrl()
    {
      server.findTodayUrl({})
      .then((res) => {
        if(res.data.code == 100 && res.data.data && res.data.data.url)
        {
          this.todayUrl = res.data.data.url;
          // var sUserAgent = navigator.userAgent.toLowerCase();
          var isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
          if(!isMobile)
          {
            // window.location.href = "https://pc-chplus.1atoshi.top";
            window.location.href = res.data.data.pcUrl;
          }
        }
      })
      .catch((error) => {

      });
    },
    clickShowBigImage(type)
    {
      this.imageType = "";
      this.imageType = type;
      this.showBigImage = true;
    },
    jumpPerson()
    {
      this.$router.push({
        path: "/personalIntroduction",
      });
    },
    equipment() {
      let ua = navigator.userAgent;
      let isWeixin = !!/MicroMessenger/i.test(ua);
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Linux") > -1; //g
      let isIos = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isWeixin) {
        this.isshowzhezhao = true;
        return false;
      }
      if (isIos) {
        Toast("此应用暂不支持 ios 版本");
        return false;
      } else {
        return true;
      }
    },
    jumpDownloadVideo() {
      if (this.equipment()) {
        window.location.href = this.leshuaAddress;
      }
    },
    jumpDownloadGame() {
      if (this.equipment()) {
        window.location.href = this.idiomAddress;
      }
    },
    jump() {
      this.$router.push({
        path: "/infos",
      });
    },
    iszhankai(index) {
      this.otheryingyongtexts[index].iszhankai =
        !this.otheryingyongtexts[index].iszhankai;
      this.otheryingyongtexts.splice(index, 1, this.otheryingyongtexts[index]);
    },
    iszhankai2(index) {
      this.yuanqiguihuatexts[index].iszhankai =
        !this.yuanqiguihuatexts[index].iszhankai;
      this.yuanqiguihuatexts.splice(index, 1, this.yuanqiguihuatexts[index]);
    },
    teammemberdetail(memberId) {
      window.location.href =
        this.todayUrl + "#/teamMemberDetail?TMid=" + memberId;
    },
    gobd(pho) {
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("Android") > -1) {
        window.Android.dialService(pho);
      } else if (/^.+(Mobile\/\w+)\s?$/.test(userAgent)) {
        window.webkit.messageHandlers.callCustomerServiceiOS.postMessage(pho);
      } else {
        document.getElementById("bdpho").setAttribute("href", "tel:" + pho);
      }
    },
    tohide() {
      if (this.kefu1) {
        this.kefu1 = false;
      }
      if (this.kefu2) {
        this.kefu2 = false;
      }
      if (this.downloadBtn) {
        this.downloadBtn = false;
      }
    },
    showkefu1() {
      // var userAgent = navigator.userAgent;
      // if (userAgent.indexOf("Android") > -1) {
      //   window.Android.saveServiceQRCode(1);
      // } else if (/^.+(Mobile\/\w+)\s?$/.test(userAgent)) {
      //   window.webkit.messageHandlers.saveWeChatQrCodeToiPhone.postMessage("1");
      // } else {
        if (this.kefu1) {
          this.kefu1 = false;
        } else {
          this.kefu1 = true;
        }
      // }
    },
    showkefu2() {
      // var userAgent = navigator.userAgent;
      // if (userAgent.indexOf("Android") > -1) {
      //   window.Android.saveServiceQRCode(2);
      // } else if (/^.+(Mobile\/\w+)\s?$/.test(userAgent)) {
      //   window.webkit.messageHandlers.saveWeChatQrCodeToiPhone.postMessage("2");
      // } else {
        if (this.kefu2) {
          this.kefu2 = false;
        } else {
          this.kefu2 = true;
        }
      // }
    },
    gaibian() {
      if(this.languageType == "en")
      {
        this.$router.push({path:"/en"})
      }
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.hash.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    //获取ios 返回参数
    isApp: function (value) {
      if (value == "ios_yuanzilian") {
        window.webkit.messageHandlers.goToMall.postMessage({});
      } else {
        this.judgeIp();
      }
    },
    huoqu(num) {
      if (num === 1) {
        // window.location.href = enumsZh.downloadUrl;
        // 需要ios 安卓传递参数
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          try {
            let isApp = window.Android.isApp();
            if (isApp == "android_yuanzilian") {
              window.Android.goToMall();
            } else {
              this.judgeIp();
            }
          } catch (err) {
            this.judgeIp();
          }
        }
        if (isiOS) {
          try {
            //1、通知IOS 传参数; isApp ios方法
            window.webkit.messageHandlers.isApp.postMessage({});
            window.isApp = this.isApp;
          } catch (err) {
            this.judgeIp();
          }
        }
      } else if (num === 2) {
        // window.location.href = "https://leshua.info";
        this.downloadApp("https://www.atoshi.info/leshua/#/");
      } else if (num === 3) {
        // window.location.href =
        //   "https://game-img.atoshi.mobi/official/box_mobile.jpg";
        this.downloadApp(
          "https://game-img.atoshi.mobi/official/box_mobile.jpg"
        );
      } else if (num === 4) {
        this.downloadApp(enumsZh.seaAtoshiDownloadUrl);
      } else if (num === 5) {
        this.downloadApp(enumsZh.chainAtoshiUrl);
      } else if (num === 9) {
        this.downloadApp(enumsZh.walletUrl);
      } else if (num === 10) {
        this.downloadApp(enumsZh.metatUrl);
      } else if (num === 11) {
        this.downloadApp(enumsZh.keyUrl);
      } else if (num === 12) {
        this.downloadApp(enumsZh.miniDaily);
      } else if (num === 13) {
        this.downloadApp(enumsZh.atoshiAI);
      } else if (num === 99) {
      //     const link = document.createElement("a");
      //    link.href = "https://download.juhaowu.cn/原子世界.apk";
      //     link.download = "原子世界.apk";
      //   // 将链接添加到页面中并触发点击事件
      //     document.body.appendChild(link);
      //      link.click();
  
      //  // 移除链接元素
      //   document.body.removeChild(link);
      //     // window.location.href="https://download.juhaowu.cn/原子世界.apk"

        this.downloadApp(enumsZh.atoshiYzsj);
      }
    },
    //  获取招聘要求
    getWorker() {
      server.listPost({}).then((res) => {
        this.worker = res.data.data.postList;
      });
    },
    donwLoadPdf() {
      // 打开外链
      this.downloadApp(this.cjwtdownload);
    },
    //  应用场景
    prev() {
      var _this = this;
      if (_this.index1 == 0) {
        _this.index1 = 3;
      }
      _this.index1 = _this.index1 - 1;
    },
    next1() {
      var _this = this;
      if (_this.index1 == 2) {
        _this.index1 = -1;
      }
      _this.index1 = _this.index1 + 1;
    },
    //动画函数
    // animate1(element, target) {
    //     clearInterval(element.timeId);
    //     //定时器的id值存储到对象的一个属性中
    //     element.timeId = setInterval(function () {
    //         //获取元素的当前的位置,数字类型
    //         var current = element.offsetLeft;
    //         //每次移动的距离
    //         var step = 10;
    //         step = current < target ? step : -step;
    //         //当前移动到位置
    //         current += step;
    //         if (Math.abs(current - target) > Math.abs(step)) {
    //             element.style.left = current + "px";
    //         } else {
    //             //清理定时器
    //             clearInterval(element.timeId);
    //             //直接到达目标
    //             element.style.left = target + "px";
    //         }
    //     }, 10);
    // },
    //  视频资料更多、收起
    videoClick() {
      this.videoShow = !this.videoShow;
      if (this.videoShow) {
        this.video = this.videos;
      } else {
        this.video = this.videos.slice(0, 6);
      }
    },
    //  跳到图片列表页
    lookPic(id) {
      // this.$router.push({
      //     path: '/picList',
      //     query: {
      //         folderId: id
      //     },
      // })
      // window.location.href = this.hrefurl + "/picList?folderId=" + id;
      // this.$router.push({
      //   path: "/picList",
      //   query: {
      //     folderId: id,
      //   },
      // });
      // 20220307 图片详情客户端做
      // 需要安卓传递参数
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        try {
          let isApp = window.Android.isApp();
          if (isApp == "android_yuanzilian") {
            let params = {
              language:"zh",
              id:id.toString()
            }
            //安卓传参 语言，id
            window.Android.showImageGallery(params.language,params.id);
          } else {
            this.$router.push({
              path: "/picList",
              query: {
                folderId: id,
              },
            });
          }
        } catch (err) {
          this.$router.push({
            path: "/picList",
            query: {
              folderId: id,
            },
          });
        }
      }
      else
      {
        this.$router.push({
          path: "/picList",
          query: {
            folderId: id,
          },
        });
      }
    },
    // playerVideoNew(item, index) {
    //   const {
    //     readVideoUrl,
    //     videoUrl480,
    //     videoUrl720,
    //     videoUrl1080,
    //     videoImg,
    //     videoTitle,
    //   } = item;
    //   this.videoUrls = readVideoUrl;
    //   this.imgurl = videoImg || "";
    //   this.videoTitle = videoTitle || "";
    //   this.$router.push({
    //     path: "/videoPlayer",
    //     query: {
    //       index: index,
    //     },
    //   });
    // },
    // playerVideoCeo() {
    //   // this.videoUrls = this.bannerVideo.readVideoUrl;
    //   // this.imgurl = this.bannerVideo.videoImg;
    //   // this.videoTitle = this.bannerVideo.videoTitle;
    //   this.$router.push({
    //     path:"/videoPlayer",
    //     query:{
    //       index:-2
    //     }
    //   })
    // },
    // playerVideo() {
    //   // this.videoUrls = this.bannerVideo.readVideoUrl;
    //   // this.imgurl = this.bannerVideo.videoImg;
    //   // this.videoTitle = this.bannerVideo.videoTitle;
    //   this.$router.push({
    //     path:"/videoPlayer",
    //     query:{
    //       index:-1
    //     }
    //   })
    // },
    playerVideo(data,routerUrl) {
      const { readVideoUrl, videoUrl480, videoUrl720, videoUrl1080, videoImg, videoTitle, youtubeId } = data
      this.videoUrls = readVideoUrl
      this.imgurl = videoImg || ""
      this.videoTitle = videoTitle || ""
      // let youtubeId = "OYeDNoLZRUU";
      this.$router.push({
        path:"/youtubeplayers",
        query:{
          youtubeId:youtubeId,
          videoUrls:readVideoUrl,
          videotitle: videoTitle,
          imgurl:videoImg,
          routerUrl:routerUrl,
          readVideoUrl:readVideoUrl,
          videoUrl480:videoUrl480,
          videoUrl720:videoUrl720,
          videoUrl1080:videoUrl1080
        }
      })
    },
    playerVideo2(item) {
      // window.location.href =
      //   this.hrefurl + "/videoList?videoId=" + item.videoId;
        this.$router.push({
        path:"/videoList",
        query:{
          videoId:item.videoId
        }
      })
    },
    gotoHome(target) {
      if (target.nodeName.toLowerCase() !== "video") {
        this.videoFlag = false;
      }
    },
    // 导航滚动封装
    scrollTos(item) {
      $(".tops").animate({ marginLeft: $(window).width() }, 500);
      $(".page-content").animate(
        { scrollTop: item - $(".top").height() },
        1500
      );
    },
    tobps() {
      this.downloadApp(window.location.origin + "/#/pdfCheck");
    },
    upFixed (num, fix) {
      // num为原数字，fix是保留的小数位数
      let result = '0'
      if (Number(num) && fix > 0) { // 简单的做个判断
        fix = +fix || 2
        num = num + ''
        if (/e/.test(num)) { // 如果是包含e字符的数字直接返回
          result = num
        } else if (!/\./.test(num)) { // 如果没有小数点
          result = num + `.${Array(fix + 1).join('0')}`
        } else { // 如果有小数点
          num = num + `${Array(fix + 1).join('0')}`
          let reg = new RegExp(`-?\\d*\\.\\d{0,${fix}}`)
          let floorStr = reg.exec(num)[0]
          if (+floorStr >= +num) {
            result = floorStr
          } else {
            let floorNumber = +floorStr + +`0.${Array(fix).join('0')}1`
            let point = /\./.test(floorNumber + '') ? '' : '.'
            let floorStr2 = floorNumber + point + `${Array(fix + 1).join('0')}`
            result = reg.exec(floorStr2)[0]
          }
        }
      }
      return result
    },
    onLoad() {
      // 获取视频 start
      server.listVideo({})
      .then((res) => {
        this.videos = res.data.data.data;
        this.video = res.data.data.data.slice(0, 6);
      })
      .catch(err=>{
        // console.log(err)
      })
      // 获取视频 end
      // 获取原子币价格 start
      // this.$post(api_findPrice).then(res => {
      //   this.findPrice = res.data.data.price;
      // });
      server.findPrice({}).then((res) => {
        if (res.data.code === 100) {
          this.findPrice = this.upFixed(new BigNumber(res.data.data.data.usdPrice).dividedBy(100),8)
          let userCoun = new BigNumber(res.data.data.userCount).plus(new BigNumber(600000));
          this.userNums = parseInt(userCoun).toLocaleString();
        } else {
          let usdPrice = 0.069028, userCount = 11330880;

          this.findPrice = this.upFixed(new BigNumber(usdPrice).dividedBy(100),8)
          let userCoun = new BigNumber(userCount).plus(new BigNumber(600000));
          this.userNums = parseInt(userCoun).toLocaleString();
        }
      })
      .catch(err => {
          let usdPrice = 0.069028, userCount = 11330880;

          this.findPrice = this.upFixed(new BigNumber(usdPrice).dividedBy(100),8)
          let userCoun = new BigNumber(userCount).plus(new BigNumber(600000));
          this.userNums = parseInt(userCoun).toLocaleString();
      })
      //白皮书和常见问题URL
     server.whitePaper({}).then((res) => {
        this.bpsdownload = res.data.data.files.whitePaperUrl;
        this.cjwtdownload = res.data.data.files.commomProblemUrl;
      });
      // 获取原子币价格 end
      // 团队成员-查询所有 start
      server.listTeamMembers({}).then((res) => {
        this.team = res.data.data.data.slice(0, 2);
        this.teams = res.data.data.data;
      });
      // 团队成员-查询所有 end
      // 常见问题-查询所有 start
      server.listCommonProblem({}).then((res) => {
        this.list = res.data.data.data.slice(0, 5);
        this.lists = res.data.data.data;
      });
      // 常见问题-查询所有 end
      // 音频资料-查找所有 start
      server.listAudio({}).then((res) => {
        this.audio = res.data.data.data.slice(0, 6);
        this.audios = res.data.data.data;
      });
      // 音频资料-查找所有 end
      //相册-查询所有 start
      server.listCultureFolder({}).then((res) => {
        this.enterprises = res.data.data.cultureFolders;
        this.enterprise = res.data.data.cultureFolders.slice(0, 6);
      });
      //企业文化-查询所有 end
      // 媒体报道-查询所有 start
      server.listNews({}).then((res) => {
        this.news = res.data.data.data.slice(0, 6);
        this.newP = res.data.data.data;
      });
      // 媒体报道-查询所有 end
    },
    Submission() {
      let body = {
        applicantName: this.form.name,
        applyPosition: this.form.region,
        contactWay: this.form.phone,
        applicantIntro: this.form.content,
      };
      if (!body.applicantName) {
        this.$showError("请填写姓名");
      } else if (!body.applyPosition) {
        this.$showError("请选择申请岗位");
      } else if (!body.contactWay) {
        this.$showError("请填写联系方式");
      } else {
        server.addApplicant(body).then((res) => {
        // server.addApplicant(body).then((res) => {
          this.$showSuccess("提交成功");
          this.form.name = "";
          this.form.region = "";
          this.form.phone = "";
          this.form.content = "";
          this.fileList = [];
          //this.$pop();
        });
      }
    },
    folderClick() {
      if (this.folderShow) {
        this.enterprise = this.enterprises.slice(0, 6);
      } else {
        this.enterprise = this.enterprises;
      }
      this.folderShow = !this.folderShow;
    },
    teamClick() {
      if (this.teamShow) {
        this.team = this.team.slice(0, 2);
      } else {
        this.team = this.teams;
      }
      this.teamShow = !this.teamShow;
    },
    joinClick() {
      if (this.joinshow) {
        $(".join-us").css({ height: "auto", overflow: "auto" });
      } else {
        $(".join-us").css({ height: "13.2rem", overflow: "hidden" });
      }
      this.joinshow = !this.joinshow;
    },
    problem() {
      this.list = this.lists;
      this.problemShow = false;
      this.problemShows = true;
    },
    problems() {
      this.list = this.list.slice(0, 5);
      this.problemShow = true;
      this.problemShows = false;
    },
    audioClick() {
      this.audio = this.audios;
      this.audioShow = false;
      this.audioShows = true;
    },
    audioClicks() {
      this.audio = this.audio.slice(0, 6);
      this.audioShow = true;
      this.audioShows = false;
    },
    NewsCli(url, id) {
      if (url) {
        window.location.href = url;
      } else {
        this.$router.push({
            path: '/newsDetails',
            query: {
                id: id
            },
        })
        // window.location.href = this.hrefurl + "/newsDetails?id=" + id;
      }
    },
    audioCli(item) {
      var userAgent = navigator.userAgent;
      if (item.audioType == 0) {
        if (item.audioFileUrl) {
          if (/^.+(Mobile\/\w+)\s?$/.test(userAgent)) {
            window.webkit.messageHandlers.getAddressId.postMessage(
              this.todayUrl + "#/audiodetail?audioId=" + item.audioId
            );
          } else {
            this.$router.push({
              path: "/audiodetail",
              query: { audioId: item.audioId },
            });
          }
        } else {
          if (/^.+(Mobile\/\w+)\s?$/.test(userAgent)) {
            window.webkit.messageHandlers.getAddressId.postMessage(
              item.audioLink
            );
          } else {
            window.location.href = item.audioLink;
          }
        }
      } else {
        if (/^.+(Mobile\/\w+)\s?$/.test(userAgent)) {
          window.webkit.messageHandlers.getAddressId.postMessage(
            this.todayUrl + "#/audioList?audioId=" + item.audioId
          );
        } else {
          this.$router.push({
            path: "/audioList",
            query: { audioId: item.audioId },
          });
        }
      }
    },
    newsClick() {
      this.news = this.newP;
      this.newShow = false;
      this.newShows = true;
    },
    newsClicks() {
      this.news = this.news.slice(0, 6);
      this.newShow = true;
      this.newShows = false;
    },
    sixClick() {
      this.sixS = false;
      this.sixShow = true;
      this.sixSs = true;
    },
    sixClicks() {
      this.sixS = true;
      this.sixShow = false;
      this.sixSs = false;
    },
    tiClick() {
      this.$pushRoute("DCReportJoinUs");
    },
    jquery() {
      // var navtop = $("#listNav").get(0).offsetTop;
      $(".page-content").scroll(function () {
        var navtop = $("#listNav").get(0).offsetTop;
        var start_height = $(".page-content").scrollTop();
        if (start_height > navtop) {
          $("#listNav2").show();
          $("#listNav2").css({
            top: "1rem",
            left: "2%",
          });
        } else {
          // $("#listNav").css({ position: "static", top: "1rem" });
          $("#listNav2").hide();
        }
      });
    },
    //定时轮播
    auto() {
      let self = this;
      this.timer = setInterval(function () {
        self.index++;
        if (self.index > 8) {
          self.index = 0;
        }
        self.play();
      }, 1500);
    },
    play() {
      let carousel = $(".six-odd-Carousel .odds");
      //获取li的下标，改变样式
      for (let i = 0; i < carousel.length; i++) {
        carousel.eq(i).css({ visibility: "hidden" });
      }
      carousel.eq(this.index).css({ visibility: "visible" });
      //获取图片的下标，实现淡入淡出
      // carousel.eq(index).fadeIn().siblings().fadeOut();
    },
    onClick(ind) {
      clearTimeout(this.time);
      clearInterval(this.timer);
      let carousel = $(".six-odd-Carousel .odds"),
        self = this;
      for (let i = 0; i < carousel.length; i++) {
        carousel.eq(i).css({ visibility: "hidden" });
      }
      this.index = ind;
      carousel.eq(this.index).css({ visibility: "visible" });
      this.time = setTimeout(function () {
        self.auto();
      }, 15000);
    },
    menuClick(ind, selector) {
      let nav = $(".navigation .nav");
      for (let i = 0; i < nav.length; i++) {
        nav.eq(i).css({ background: "#fff", color: "#000" });
      }
      nav.eq(ind).css({ background: "#3E9BE8", color: "#fff" });
      var anchor = this.$el.querySelector(selector);
      $(".page-content").animate({ scrollTop: anchor.offsetTop - 125 }, 1500);
    },
    gClick() {
      $(".money").animate({ height: "9.4rem" }, 1000);
      this.bt1 = false;
      this.bt2 = true;
    },
    bClick() {
      $(".money").animate({ height: "2.8rem" }, 1000);
      this.bt1 = true;
      this.bt2 = false;
    },
    tClick() {
      $(".tdteam").animate({ height: "20rem" }, 1000);
      this.td1 = false;
      this.td2 = true;
    },
    dClick() {
      $(".tdteam").animate({ height: "3rem" }, 1000);
      this.td1 = true;
      this.td2 = false;
    },
    sClick() {},
    xClick() {},
    handleRemove(file, fileList) {},
    handlePreview(file) {},
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    menuMenu() {
      let lefts = parseFloat($(".tops").css("marginLeft"));
      let clientWidth = $(window).width();

      if (lefts == clientWidth) {
        $(".tops").animate({ "margin-left": 0 }, 500);
      } else {
        $(".tops").animate({ "margin-left": document.body.clientWidth }, 500);
      }
    },
    gotoScroll0() {
      this.scrollTos(this.$refs.scroll0.offsetTop);
    },
    gotoScroll1() {
      this.scrollTos(this.$refs.scroll1.offsetTop);
    },
    gotoScroll2() {
      this.scrollTos(this.$refs.scroll2.offsetTop);
    },
    gotoScroll3() {
      this.scrollTos(this.$refs.scroll3.offsetTop);
    },
    gotoScroll4() {
      this.scrollTos(this.$refs.scroll4.offsetTop);
    },
    gotoScroll5() {
      this.scrollTos(this.$refs.scroll5.offsetTop);
    },
    gotoScroll6() {
      this.scrollTos(this.$refs.scroll6.offsetTop);
    },
    gotoScroll7() {
      this.scrollTos(this.$refs.scroll7.offsetTop);
    },
    gotoScroll10() {
      this.scrollTos(this.$refs.scroll10.offsetTop);
    },
    gotoScroll8() {
      this.scrollTos(this.$refs.scroll8.offsetTop);
    },
    gotoScroll9() {
      this.scrollTos(this.$refs.scroll9.offsetTop);
    },
    gotoScroll11() {
      this.scrollTos(this.$refs.scroll11.offsetTop);
    },
    // 下载app 打开外链
    downloadApp(url) {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        try {
          window.Android.downloadSeaAtoshi(url);
        } catch (error) {
          window.location.href = url;
        }
      } else if (isiOS) {
        try {
          window.webkit.messageHandlers.downloadSeaAtoshi.postMessage(url);
        } catch (error) {
          window.location.href = url;
        }
      } else {
        window.location.href = url;
      }
    },
    // 点击下载 判断ip
    judgeIp() {
      this.showVantOverlay = true;
      // if (!window.localIP) {
      //   window.location.href = enumsZh.downloadUrl;
      //   return;
      // }
      let _this = this;
      $.ajax({
        type: "GET",
        url: 'https://aggshop.juhaowu.cn/intcoreapi/base/ipFrom',
        contentType: "application/json;charset=utf-8",
        data: {},
        headers:{'language':'chinese'},
        success: function (res) {
            _this.showVantOverlay = false;
            if (res.data) {
                if (res.data.isChina) {
                // window.location.href = enumsZh.downloadUrl;
                _this.downloadApp(enumsZh.downloadUrl);
                } else {
                // window.location.href = enumsZh.downloadGlobalUrl;
                _this.downloadApp(enumsZh.seaAtoshiDownloadUrl);
                }
            } else {
                // window.location.href = enumsZh.downloadUrl;
                _this.downloadApp(enumsZh.downloadUrl);
            }
        },
        fail:function (error) {
            _this.showVantOverlay = false;
        },
    })
    //   server.chinaIpJudge2({})
    //     .then((res) => {
    //       this.showVantOverlay = false;
    //       if (res.data && res.data.data) {
    //         if (res.data.data.isChina) {
    //           // window.location.href = enumsZh.downloadUrl;
    //           this.downloadApp(enumsZh.downloadUrl);
    //         } else {
    //           // window.location.href = enumsZh.downloadGlobalUrl;
    //           this.downloadApp(enumsZh.seaAtoshiDownloadUrl);
    //         }
    //       } else {
    //         // window.location.href = enumsZh.downloadUrl;
    //         this.downloadApp(enumsZh.downloadUrl);
    //       }
    //     })
    //     .catch((error) => {
    //       this.showVantOverlay = false;
    //       // window.location.href = enumsZh.downloadUrl;
    //       // this.downloadApp(enumsZh.downloadUrl);
    //     });
    },
  },
  deactivated()
  {
    this.languageType = "zh"
  }
};
</script>

<style scoped>
.session1 a {
  color: #00a0ea;
  text-decoration: underline;
}

#Home {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.banner .banner-bottom .jian {
  width: 0.24rem;
  height: 0.24rem;
  vertical-align: middle;
  margin-right: 0.1rem;
  margin-top: -0.04rem;
}

.imgs {
  position: relative;
  height: 3.4rem;
  overflow: hidden;
  padding: 0rem 0.5rem;
  margin: 0.6rem 0;
}

.prev,
.next {
  line-height: 0.7rem;
  text-align: center;
  position: absolute;
  top: 50%;
  margin-top: -0.23rem;
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
}

.prev img,
.next img {
  vertical-align: middle;
  width: 0.26rem;
  height: 0.47rem;
}

.prev {
  left: 0.6rem;
}

.next {
  right: 0.6rem;
}

.imgs .imgList {
  display: inline-block;
  width: 3.1rem;
  height: 3.4rem;
  margin-right: 0.2rem;
}

.imgs img:nth-of-type(2n) {
  margin-right: 0;
}

.enterpriseImg {
  /* background: url("/static/img/xiangCeBj.png") no-repeat; */
  background-size: 100%;
  width: 2.16rem;
  height: 2.16rem;
}

.enterpriseImg img {
  width: 1.95rem;
  height: 1.95rem;
}

.name-describe h3 {
  margin-top: 0.1rem;
  min-height: 0.76rem;
  font-weight: normal;
  font-size: 0.26rem;
  line-height: 0.38rem;
  color: #333333;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.name-describe p {
  font-size: 0.24rem;
  color: #999999;
}

body {
  background: #fff;
}

button {
  border: none;
}

.top {
  width: 100%;
  height: 1rem;
  position: fixed;
  top: 0;
  background: #fff;
  z-index: 999;
}

.top-logo {
  float: left;
  width: 5rem;
  height: 1rem;
}

.top-logo img {
  width: 1.8rem;
  height: 0.6rem;
  margin: 0 0 0 0.2rem;
}

.top-right {
  float: right;
  width: auto;
  height: 1rem;
}

.top-right div {
  float: right;
}

.top-right button {
  width: 1.6rem;
  height: 0.5rem;
  font-size: 0.25rem;
  margin-top: 0.25rem;
  background: #243d69;
  color: #fff;
  border-radius: 0.1rem;
}

.team-content {
  box-sizing: border-box;
  padding: 0.2rem;
  background-color: #f5f5f5;
  color: #333;
}

.top-right img {
  width: 0.7rem;
  margin-top: 0.15rem;
}

/* nav菜单 start */
.tops_cont {
  width: 100%;
  min-height: 11.3rem;
}
.tops {
  width: 100%;
  background: #f5f5f5;
  position: fixed;
  top: 1rem;
  z-index: 999999999999999999;
  text-align: center;
  line-height: 1rem;
  padding-top: 0.5rem;
  color: #111;
  overflow-y: auto;
}

/* nav菜单 end */
.banner {
  width: 100%;
  height: 6.76rem;
  background: url("https://video2.juhaowu.cn/static-web/mobile_img/mobile_zh/banner.jpg");
  background-size: 100% 100%;
  padding-top: 1rem;
  position: relative;
  z-index: 1;
}

.banner img {
  margin: 0 auto;
  width: 7rem;
  height: 1.5rem;
}

#particles-js {
  width: 100%;
  height: 5.6rem;
  position: absolute;
  top: 1rem;
  left: 0;
  z-index: -1;
}

.audio {
  text-align: center;
  display: flex;
  justify-content: center;
}
.audio .audioCenter
{
  width: auto;
  height: 0.8rem;
  margin: 0 auto;
  border-radius: 50px;
  background: #3da0d1;
  margin-top: -0.4rem;
  display: flex;
  justify-content: space-between;
}

.audio img {
  height: 0.8rem;
  width: auto;
}

/* .audio-img {
  float: left;
} */

.audio-font {
  /* float: right; */
  line-height: 0.8rem;
  margin-right: 0.26rem;
  margin-left: 0.26rem;
  color: #fff;
  font-size: 0.33rem;
}

.fontFont {
  width: 100%;
  height: 0.3rem;
  margin-top: 0.2rem;
  text-align: center;
  font-size: 0.3rem;
  color: #fff;
}
.fontFont2
{
  width: 100%;
  height: 0.3rem;
  margin-top: 0.2rem;
  text-align: center;
  font-size: 0.3rem;
  margin-bottom: 0.2rem;
  color: #fff;
}

.banner-bottom {
  width: 100%;
  height: 2rem;
  text-align: center;
  font-size: 0.24rem;
}

.banner-bottom button,
.banner-bottom a {
  width: 2.2rem;
  height: 0.5rem;
  display: inline-block;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 5px;
  vertical-align: middle;
  line-height: 0.46rem;
  margin-top: 0.2rem;
}

/* .banner-bottom a:nth-child(1) {
  border: 1px solid #51dfef;
  background: #48c5e0;
} */

.banner-bottom .bannerCeo{
  width: 2.6rem;
}
.content-top {
  width: 100%;
  height: 1.4rem;
  margin-top: 0.3rem;
  text-align: center;
  line-height: 1.4rem;
  font-size: 0.4rem;
  /* font-weight: bold; */
}

.content-top span {
  letter-spacing: -4px;
  color: #3f9de8;
}

.content-top img {
  position: relative;
  top: 0.2rem;
  width: 1rem;
}

.article {
  width: 96%;
  margin: 0px auto;
  color: #666;
  font-size: 0.22rem;
  line-height: 0.46rem;
  margin-bottom: 0.4rem;
}

.six {
  position: relative;
  height: 7.8rem;
}

.six-odd {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
}

.odd {
  float: left;
  width: 33.33%;
  height: 2.5rem;
  text-align: center;
  z-index: 99999;
}

.odd-img {
  width: 100%;
  height: 2rem;
  padding-top: 0.4rem;
}

.odd-img img {
  width: 1.3rem;
  text-align: center;
}

.six-odd-Carousel {
  position: absolute;
  top: 0;
  pointer-events: none;
  display: flex;
  flex-flow: wrap;
}

.six-odd-Carousel .odds {
  position: relative;
  /* font-size: 0.12rem; */
  /* float: left; */
  width: 33.33%;
  min-height: 2.5rem;
  text-align: center;
  background: linear-gradient(#3e9be8, #3b86e8);
  visibility: hidden;
  color: #fff;
}

.odds p {
  /* position: absolute; */
  width: 100%;
  /* margin-left: -0.5rem; */
  font-size: 0.16rem;
  /* -webkit-transform-origin-x: 0.32;
  -webkit-transform: scale(0.7); */
}

.odds img {
  width: 100%;
  height: 100%;
}
.introduction {
  width: 100%;
  height: auto;
}

.introduction img {
  width: 95%;
  margin-left: 2.5%;
}
.videoFlex{
  width: 96%!important;
  display: flex;
  justify-content: space-between;
}
.videoFlex .liaoIntroduction
{
  padding: 0 0.22rem;
  color: #FFF;
  background: #00A0EA;
  border-radius: 0.04rem;
  line-height: 0.6rem;
  height: 0.6rem;
  text-align: center;
  font-size: 0.24rem;
}
.title-blue {
  width: 100%;
  height: 0.7rem;
  line-height: 0.7rem;
  position: relative;
}

.title-blue a {
  position: absolute;
  right: 0.2rem;
}

.title-left {
  width: 0.08rem;
  height: 0.36rem;
  background: #3f9ce8;
  position: absolute;
  top: 0.17rem;
  left: 0.2rem;
}

.title-font {
  position: absolute;
  font-size: 0.31rem;
  left: 0.36rem;
  top: 0.03rem;
  /* font-weight: bold; */
}

.tblue {
  left: 0.2rem;
  color: #3f9ce8;
}

.application {
  width: 96%;
  height: auto;
  margin: 0 auto;
}

.application-three {
  width: 100%;
  min-height: 1.8rem;
  margin-top: 0.3rem;
  display: flex;
}
.application-two {
  width: 100%;
  min-height: 1.8rem;
  margin-top: 0.3rem;
  display: flex;
}
.three-left {
  width: 50%;
  height: 1.8rem;
  /*float: left;*/
}

.three-left img {
  width: 100%;
  height: 100%;
}

.three-right {
  width: 50%;
  height: 100%;
  /*float: right;*/
  padding-left: 0.2rem;
  text-align: right;
  margin-top: 0.1rem;
}

.three-right p:nth-child(1) {
  font-weight: bold;
}

.three-right p:nth-child(2) {
  font-size: 0.2rem;
  color: #666;
  line-height: 0.4rem;
}
.application-two .three-right {
  margin-top: 0.1rem;
}
.application-two .three-right span {
  font-size: 0.24rem;
  margin-left: 0.1rem;
  padding: 0.04rem;
  color: #fff;
  background: #00a0ea;
  border-radius: 0.1rem;
}
.application-two .three-right img {
  margin-right: 0.04rem;
  width: 0.2rem;
  height: 0.2rem;
  vertical-align: middle;
}
.three-l {
  float: right;
}

.three-r {
  float: left;
  text-align: left;
  padding-left: 0;
  padding-right: 0.2rem;
}

.more {
  width: 100%;
  height: 1.6rem;
  line-height: 1.6rem;
  text-align: center;
}

.more button {
  width: 1.5rem;
  height: 0.4rem;
  letter-spacing: 0.1rem;
  text-indent: 0.1rem;
  font-size: 0.2rem;
  border-radius: 0.05rem;
  background: #3f9ce8;
  color: #fff;
}

.video {
  width: 96%;
  height: auto;
  margin: 0 auto;
  margin-top: 0.2rem;
}

.video-folder{
  width: 6.9rem;
}

.video-t {
  width: 33.33%;
  /*height: 3.55rem;*/
  float: left;
}

.folder {
  width: 2.16rem;
  margin-top: 0.6rem;
  margin-right: 0.2rem;
  float: left;
}
.folder:nth-child(3n){
  margin-right: 0;
}

.video-img {
  width: 90%;
  height: 2rem;
  margin: 0 auto;
}

.video-img img {
  width: 100%;
  height: 100%;
}

.video-font {
  font-size: 0.26rem;
  color: #666;
  width: 90%;
  margin: 0 auto;
  margin-top: 0.1rem;
  text-align: center;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.video-font2 {
  font-size: 0.26rem;
  color: #666;
  width: 90%;
  margin: 0 auto;
  margin-top: 0.1rem;
  text-align: center;
}
.video-font2 h3{
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.video-f {
  text-align: left;
}

.video-f p:nth-child(1) {
  color: #000;
  font-size: 0.26rem;
}

.video-f p:nth-child(2) {
  font-size: 0.24rem;
}

.video-tt {
  height: 3.6rem;
}

/*.enterprise {*/
/*height: 2.3rem;*/
/*}*/
.money {
  width: 96%;
  height: 2.8rem;
  margin: 0 auto;
  margin-top: 0.2rem;
  overflow: hidden;
}

.money-left {
  width: 35%;
  height: auto;
  float: left;
  margin: 30px 0;
  padding-right: 0.3rem;
}

.money-left img {
  width: 100%;
}

.money-font {
  width: 65%;
  height: auto;
  float: left;
}

.money-font div {
  /* width: 145%;
        margin-left: -1rem;
        margin-top: -1.8rem;
        -webkit-transform-origin-x: 0.32;
        -webkit-transform: scale(0.6); */
  /* padding-left: 0.2rem; */
}

.ttx {
  /* margin-top: -1rem; */
}

.team {
  width: 96%;
  height: auto;
  margin: 0 auto;
  margin-bottom: 0.5rem;
  position: relative;
}

.userName {
  width: 100%;
  height: 0.8rem;
  line-height: 0.8rem;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  bottom: 0.01rem;
  color: #fff;
}

.team-img {
  width: 100%;
  height: auto;
  position: relative;
}

.team-img img {
  width: 100%;
  cursor: pointer;
}

.titleImg {
  width: 96%;
  height: auto;
  margin: 0 auto;
  line-height: 0.5rem;
}

.titleImg img {
  width: 100%;
  height: auto;
}

.navigation {
  width: 96%;
  height: auto;
  margin: 0 auto;
}

.navigation .nav {
  width: 25%;
  height: 0.8rem;
  font-size: 0.22rem;
  float: left;
  text-align: center;
  font-weight: bold;
  line-height: 0.8rem;
  background: #fff;
  border: 1px solid #f0f0f0;
}

.listMe {
  width: 96%;
  height: auto;
  margin: 0 auto;
  line-height: 0.5rem;
}

input {
  border: none;
  background: #dbf4fe;
}

#name {
  width: 20%;
}

.upload-demo {
  text-align: center;
}

.but {
  width: 30%;
  margin-top: 0.4rem;
  height: 0.7rem;
  background: #3e9be8;
  color: #fff;
  margin-left: 35%;
}

.six-title {
  height: 1rem;
  margin-top: 0.5rem;
  position: relative;
}

.six-t-i {
  position: absolute;
  left: 0;
  width: 0.8rem;
  height: 0.66rem;
  float: left;
  z-index: 1001;
  background: url("https://video2.juhaowu.cn/static-web/mobile_img/mobile_zh/jiaru-tuxing.png");
  background-size: 100% 100%;
  text-align: center;
  line-height: 0.66rem;
  color: #fff;
}

/* .six-t-i img{
            width: 100%;
            z-index: 666666666666669;
        } */
.six-t-f {
  width: 3.6rem;
  height: 0.6rem;
  float: left;
  z-index: 1;
  background: url("https://video2.juhaowu.cn/static-web/mobile_img/mobile_zh/jiaru-tuxing1.png");
  background-size: 100% 100%;
  position: absolute;
  left: 0.5rem;
  padding-left: 0.2rem;
  top: 0.1rem;
  line-height: 0.6rem;
}

.six-cont p:nth-child(2) {
  font-size: 13px;
  color: #666;
}

.six-cont p:nth-child(3) {
  font-size: 13px;
  color: #666;
}

.six-cont p:nth-child(4) {
  font-size: 13px;
  color: #666;
}

.six-cont p:nth-child(5) {
  font-size: 13px;
  color: #666;
}

.six-cont p:nth-child(6) {
  font-size: 13px;
  color: #666;
}

.six-cont p:nth-child(7) {
  font-size: 13px;
  color: #666;
}

.six-cont p:nth-child(8) {
  font-size: 13px;
  color: #666;
}

.six-cont p:nth-child(9) {
  font-size: 13px;
  color: #666;
}

.six-cont p:nth-child(10) {
  font-size: 13px;
  color: #666;
}

.six-cont p:nth-child(11) {
  font-size: 13px;
  color: #666;
}

.six-cont p:nth-child(12) {
  font-size: 13px;
  color: #666;
}

.six-cont p:nth-child(13) {
  font-size: 13px;
  color: #666;
}

.six-cont p:nth-child(14) {
  font-size: 13px;
  color: #666;
}

.six-cont p:nth-child(15) {
  font-size: 13px;
  color: #666;
}

.font-blue {
  color: #3f9ce8;
  font-size: 0.23rem;
}

.clear-top {
  margin-top: -0.5rem;
}

.huid {
  width: 100%;
  height: auto;
  background: #f5f5f4;
  padding-bottom: 0.2rem;
}

.black {
  color: #444;
}

.huid p {
  font-size: 12px !important;
  color: #666;
}

.fb {
  font-size: 0.31rem;
}

.tr {
  height: 16.3rem;
  position: relative;
}

.tr-l {
  width: 48%;
  position: absolute;
  left: 0;
  text-align: right;
  height: 6rem;
  font-size: 0.28rem;
}

.tr-c {
  width: 4%;
  position: absolute;
  left: 48%;
  height: 16rem;
}

.tr-r {
  width: 48%;
  height: 6rem;
  position: absolute;
  right: 0;
  font-size: 0.28rem;
}

.c-s {
  width: 1px;
  height: 15.7rem;
  background: #3f9ce8;
  position: absolute;
  left: 49%;
}

.c {
  color: #fff;
  position: absolute;
  background: #3f9ce8;
  width: 0.4rem;
  height: 0.4rem;
  left: -0.08rem;
  line-height: 0.45rem;
  border-radius: 50px;
  text-align: center;
  font-size: 0.3rem;
}

.c2 {
  top: 1.4rem;
}

.c3 {
  top: 2.8rem;
}

.c4 {
  top: 3.7rem;
}

.c5 {
  top: 7.1rem;
}

.c6 {
  top: 9.5rem;
}

.c7 {
  top: 10.5rem;
}

.c8 {
  top: 11.9rem;
}

.c9 {
  top: 13.8rem;
}

.c10 {
  top: 15.3rem;
}

.l {
  padding-right: 0.15rem;
  position: absolute;
}

.r {
  padding-left: 0.1rem;
  position: absolute;
}

.fore {
  width: 100%;
  height: 1.2rem;
  font-size: 0.2rem;
  margin-top: 0.4rem;
}

.fore div {
  width: 50%;
  height: 100%;
  float: left;
}

.fore button {
  background: #3f9ce8;
  width: 95%;
  height: 0.5rem;
  border-radius: 2px;
  margin-bottom: 0.2rem;
  color: #fff;
}

.fore div:nth-child(1) {
  text-align: right;
  padding-right: 0.1rem;
}

.fore div:nth-child(2) {
  text-align: left;
  padding-left: 0.1rem;
}

.sp {
  font-size: 0.25rem;
}

.sp button {
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
}

.mores {
  height: 1rem;
  line-height: 1rem;
}

.cooperation {
  width: 100%;
  height: auto;
}

.coop {
  float: left;
  width: 33.33%;
  height: 1.1rem;
  text-align: center;
}

.coop img {
  width: 70%;
}

.blue-div {
  margin-top: 0.2rem;
  width: 100%;
  height: 7rem;
  background: linear-gradient(#33c3f8, #155bba);
  color: #fff;
  padding-bottom: 5.7rem;
}

.cti {
  color: #fff;
}

.cti img {
  height: 0.7rem;
}

.fontbl {
  width: 100%;
  text-align: center;
  font-size: 0.24rem;
  line-height: 0.5rem;
}

.erw {
  width: 100%;
  float: left;
  line-height: 0.4rem;
  margin-top: 0.4rem;
  word-wrap: break-word;
}

.erw1 {
  text-align: center;
  font-size: 0.2rem;
}

.erw2 {
  padding-left: 0.25rem;
  padding-right: 0.05rem;
  text-align: left;
  font-size: 0.2rem;
}

.erw img {
  width: 2rem;
  margin-top: 0.05rem;
}

.black-div {
  width: 100%;
  height: 1.6rem;
  margin-top: -0.1rem;
  background: #111;
  color: #fff;
  padding: 0.2rem;
  padding-left: 0;
  padding-right: 0;
}

.black-div .fontbl {
  line-height: 0.6rem;
  font-size: 0.2rem;
}

.black-div .fontbl p img {
  width: 0.24rem;
}

.black-div .fontbl p a {
  vertical-align: middle;
}

#my-video {
  /* object-fit: cover;
              object-position: center center; */
}

.xxi-i,
.xxi-f {
  width: 96%;
  height: auto;
  margin: 0 auto;
  font-size: 0.2rem;
  color: #666;
  line-height: 0.4rem;
}

.xxi-i img {
  width: 100%;
  height: 2rem;
}

.jj {
  line-height: 0.5rem;
}

.btna {
  width: 100%;
  height: 0.5rem;
  text-align: center;
  font-size: 0.5rem;
}

.tdteam {
  height: 3rem;
  overflow: hidden;
}

img {
  object-fit: contain;
}

/* .poTop {
  position: relative;
}

.poTop a {
  position: absolute;
  right: 0.5rem;
  top: 0;
  font-size: 0.3rem;
  color: #3f9ce8;
  text-decoration: underline;
}
.poTop .baipishu {
  position: absolute;
  top: 0;
  left: -0.5rem;
  font-size: 0.3rem;
  color: #3f9ce8;
  text-decoration: underline;
} */
/* .content-top {
  width: 100%;
  height: 1.4rem;
  margin-top: 0.3rem;
  text-align: center;
  line-height: 1.4rem;
  font-size: 0.4rem;
}

.content-top span {
  letter-spacing: -4px;
  color: #3f9de8;
}

.content-top img {
  position: relative;
  top: 0.2rem;
  width: 1rem;
} */
.question{
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.question a{
  font-size: 0.3rem;
  color: #3f9ce8;
  text-decoration: underline;
}
.question div{
  display: flex;
  justify-content: center;
}
.question span{
  font-size: 0.4rem;
  margin: 0 0.1rem;
}
.question img{
  width: 1rem;
}
select {
  background: url("https://video2.juhaowu.cn/static-web/mobile_img/mobile_zh/xiala.png") no-repeat 54px 12px;
}
.huoqu .left {
  width: 30%;
  display: inline-block;
  float: left;
  margin-right: 6px;
  margin-left: 6px;
}
.blue-div2 {
  margin-top: 0.4rem;
  width: 100%;
  min-height: 7rem;
  background: linear-gradient(#33c3f8, #155bba);
  color: #fff;
}
.foot_link {
  width: 6.9rem;
  margin: 0 auto;
  padding-top: 0.68rem;
  padding-bottom: 0.5rem;
}
.p11 {
  font-size: 0.24rem;
  font-weight: bold;
}
.p22 {
  font-size: 0.22rem;
  margin-top: 0.2rem;
}
.gllink {
  border-bottom: 1px solid #ffffff;
}
.weixins {
  margin-top: 0.24rem;
}
.wx_item {
  display: inline-block;
  width: 1.4rem;
  font-size: 0.2rem;
  position: relative;
  text-align: center;
}
.wx_item img.wx_img {
  width: 0.6rem;
  height: 0.6rem;
  cursor: pointer;
}
.lianjies {
  margin-top: 0.18rem;
}
.lianjies a {
  margin-right: 0.3rem;
}
.lianjies a img {
  margin-bottom: 0.2rem;
  width: 0.6rem;
  height: 0.6rem;
}
.shengming_box {
  width: 100%;
  margin-top: 0.4rem;
}
.span1 {
  font-size: 0.24rem;
}
.span2 {
  font-size: 0.2rem;
  margin-top: 0.16rem;
}
.banquan_foot {
  width: 100%;
  margin-top: 0.45rem;
  padding-bottom: 0.14rem;
  font-size: 0.2rem;
  text-align: center;
}
.kefu1_img {
  width: 1.2rem;
  height: 1.1rem;
  position: absolute;
  top: -0.26rem;
  right: -0.4rem;
  z-index: 200;
  transition: display 2s;
  -moz-transition: display 2s; /* Firefox 4 */
  -webkit-transition: display 2s; /* Safari 和 Chrome */
  -o-transition: display 2s; /* Opera */
}
.kefu2_img {
  width: 1.2rem;
  height: 1.1rem;
  position: absolute;
  top: -0.26rem;
  right: -0.4rem;
  z-index: 200;
  transition: display 2s;
  -moz-transition: display 2s; /* Firefox 4 */
  -webkit-transition: display 2s; /* Safari 和 Chrome */
  -o-transition: display 2s; /* Opera */
}
.changjing1_box {
  width: 96%;
  height: auto;
  margin: 0 auto;
  margin-top: 0.57rem;
  position: relative;
}
.changjing1_img {
  width: 3.03rem;
  height: 2.15rem;
  position: relative;
  z-index: 10;
}
.changjing1_top_text_box {
  position: absolute;
  z-index: 15;
  top: 0.19rem;
  left: 2.11rem;
  display: flex;
  align-items: center;
  width: 4.8rem;
  height: 2.216rem;
  background: #ffffff;
  border-radius: 0.05rem;
  box-shadow: 0.05rem 0.05rem 0.18rem rgba(7, 0, 2, 0.3);
}
.changjing1_top_text {
  width: 4.5rem;
  margin: 0 auto;
  /* margin-top: 0.12rem; */
  color: #222222;
  font-size: 0.24rem;
  line-height: 0.41rem;
}
.zuoyinhao {
  width: 0.22rem;
  height: 0.21rem;
  position: absolute;
  left: 1.15rem;
  top: -0.13rem;
}
.youyinhao {
  width: 0.22rem;
  height: 0.21rem;
  position: absolute;
  right: 0.26rem;
  bottom: -0.13rem;
}
.changjing1_bott {
  width: 96%;
  min-height: 13.5rem;
  margin: 0.36rem auto 0.64rem;
  position: relative;
}
.changjing1_bott_left_box {
  width: 3rem;
  position: relative;
}
.changjing1_bott_left_text {
  color: #333333;
  font-size: 0.2rem;
  line-height: 0.29rem;
  position: absolute;
  right: 0;
}
.changjing1_bott_left_text img {
  margin-top: 0.16rem;
  width: 3rem;
  height: 1.3rem;
}
.changjing1_bott_left_text1 {
  top: 0.17rem;
}
.changjing1_bott_left_text2 {
  top: 5.2rem;
}
.changjing1_bott_left_text3 {
  top: 8.22rem;
}
.changjing1_bott_zhong_box {
  width: 0.53rem;
  position: relative;
  top: 0;
  left: 3.2rem;
}
.shutiao {
  width: 0.034rem;
  height: 12.308rem;
  background: #cccccc;
  position: absolute;
  top: 0.25rem;
  left: 0.24rem;
  z-index: 15;
}
.xiaoyuandian {
  width: 0.52rem;
  height: 0.52rem;
  position: absolute;
  left: 0;
  z-index: 20;
}
.xiaoyuandian1 {
  top: 0;
}
.xiaoyuandian2 {
  top: 1.8rem;
}
.xiaoyuandian3 {
  top: 5.03rem;
}
.xiaoyuandian4 {
  top: 6.01rem;
}
.xiaoyuandian5 {
  top: 8.1rem;
}
.xiaoyuandian6 {
  top: 9.1rem;
}
.changjing1_bott_right_box {
  width: 3rem;
  position: relative;
  top: 0;
  left: 3.86rem;
}
.changjing1_bott_right_text {
  color: #333333;
  font-size: 0.2rem;
  line-height: 0.29rem;
  position: absolute;
  left: 0;
}
.changjing1_bott_right_text img {
  margin-top: 0.16rem;
  width: 3rem;
  height: 1.3rem;
}
.changjing1_bott_right_text1 {
  top: 1.96rem;
}
.changjing1_bott_right_text2 {
  top: 6.16rem;
}
.changjing1_bott_right_text3 {
  top: 9.2rem;
}
img.zhankai {
  width: 0.41rem;
  vertical-align: top;
}
img.shouqi {
  width: 0.41rem;
  transform: rotate(180deg);
  vertical-align: top;
}
.webdown_box {
  width: 100%;
  min-height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.65);
  z-index: 9999;
  top: 0;
}
.webdown_box img {
  width: 2.75rem;
  position: absolute;
  top: 0;
  right: 0.4rem;
  z-index: 99999;
}
/* 20221205 */
.downloadBtn
{
  position: relative;
}
.downloadBtn i{
  position: absolute;
  top: 0.5rem;
  left: 0;
  width: 2.20rem;
  background: #FFFFFF;
  box-shadow: 0 0.01rem 0.09rem 0 rgba(3,3,3,0.14);
  border-radius: 0 0 0.1rem 0.1rem;
}
.downloadBtn p{
  font-size: 0.24rem;
  color: #333;
  line-height: 0.5rem;
  text-align: center;
  border-bottom: 0.01rem solid #EEE;
}
.downloadBtn p:nth-child(2){
  border-bottom: none;
}

</style>
<style>
.el-carousel__container {
  height: 180px;
}
.el-carousel__item {
  margin-left: 15px;
}
.el-carousel__arrow {
  top: 30% !important;
  background-color: rgba(31, 45, 61, 0.71) !important;
}
.van-overlay {
  z-index: 9999;
}
.van-overlay .van-loading--spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.page-content .whatAppCode_img
{
  padding: 0;
}
.page-content .whatAppCode_img img {
  display: block;
  width: 4rem;
  height: 4rem;
}
</style>



// WEBPACK FOOTER //
// src/page_ch/home.vue